var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: "100%",
    width: "100%",
    viewBox: "0 0 830 568",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M972,362C972,362,256,362,256,362C256,362,256,750,256,750C256,750,972,750,972,750C972,750,972,362,972,362Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-86,-240)",
    id: "i1"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)",
    id: "i2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(760.504,754.927)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -9; 0; -9; 0; 0",
    keyTimes: "0; 0.257475; 0.498339; 0.755814; 0.996678; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i3",
    transform: "translate(-760.504,-754.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,771.504,715.479)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#01527f",
    d: "M-54.642,36.204C-45.927,19.174,-33.881,3.13,-17.111,-6.075C-1.323,-14.741,17.308,-16.672,33.754,-24.012C41.33,-27.394,48.397,-31.916,54.642,-37.378C52.246,-22.037,49.741,-6.364,42.422,7.33C37.015,17.447,29.046,26.353,25.879,37.378"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,790.766,718.875)",
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M31.775,-34.452C25.443,-24.306,18.036,-15.166,9.248,-7.048C1.131,0.451,-7.755,7.027,-16.128,14.209C-16.345,6.559,-17.149,-1.061,-18.55,-8.585C-18.763,-9.728,-20.506,-9.244,-20.294,-8.104C-18.871,-0.46,-18.077,7.28,-17.902,15.053C-17.897,15.272,-17.784,15.409,-17.677,15.546C-18.463,16.235,-19.277,16.891,-20.051,17.595C-25.201,22.276,-29.868,27.472,-33.352,33.525C-33.934,34.536,-32.371,35.448,-31.79,34.438C-25.33,23.215,-14.847,15.381,-4.919,7.424C-2.566,5.538,-0.218,3.629,2.101,1.683C2.245,1.733,2.375,1.812,2.556,1.777C8.297,0.658,14.082,-0.204,19.901,-0.8C21.048,-0.918,21.06,-2.728,19.901,-2.609C14.728,-2.079,9.585,-1.31,4.47,-0.379C10.532,-5.587,16.372,-11.063,21.535,-17.144C25.902,-22.288,29.768,-27.819,33.338,-33.539C33.956,-34.53,32.391,-35.439,31.775,-34.452Z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(673.825,752.554)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 6; 0; 6; 0; 0",
    keyTimes: "0; 0.257475; 0.498339; 0.755814; 0.996678; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i6",
    transform: "translate(-673.825,-752.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,707.825,655.092)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#015e95",
    d: "M-70.849,97.536C-66.99,66.748,-52.777,37.35,-31.042,15.205C-15.154,-0.982,4.422,-13.229,20.028,-29.688C37.994,-48.635,50.2,-72.972,54.642,-98.702C74.94,-56.005,76.245,-4.692,58.145,38.982C49.834,59.035,37.632,77.618,32.469,98.702"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i7",
    transform: "matrix(1,0,0,1,713.38,668.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-1.146,-21.66C-2.399,-7.267,-0.978,7.274,-0.169,21.656C-0.104,22.814,1.706,22.821,1.64,21.656C0.831,7.274,-0.59,-7.267,0.663,-21.66C0.764,-22.82,-1.046,-22.813,-1.146,-21.66C-1.146,-21.66,-1.146,-21.66,-1.146,-21.66Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,747.012,659.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-16.41,8.039C-5.166,3.2,6.079,-1.638,17.323,-6.477C18.39,-6.936,17.469,-8.495,16.41,-8.039C5.166,-3.2,-6.079,1.638,-17.323,6.477C-18.39,6.936,-17.469,8.495,-16.41,8.039C-16.41,8.039,-16.41,8.039,-16.41,8.039Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,712.662,709.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-16.41,8.039C-5.166,3.2,6.079,-1.638,17.323,-6.477C18.39,-6.936,17.469,-8.495,16.41,-8.039C5.166,-3.2,-6.079,1.638,-17.323,6.477C-18.39,6.936,-17.469,8.495,-16.41,8.039C-16.41,8.039,-16.41,8.039,-16.41,8.039Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,681.544,707.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-5.979,-21.636C-4.076,-6.816,-0.688,7.75,4.189,21.875C4.567,22.969,6.316,22.499,5.934,21.394C1.113,7.431,-2.288,-6.983,-4.17,-21.636C-4.316,-22.775,-6.127,-22.79,-5.979,-21.636C-5.979,-21.636,-5.979,-21.636,-5.979,-21.636Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,719.465,658.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-43.698,96.095C-34.679,70.08,-15.686,49.512,-0.352,27.171C8.005,14.995,14.676,1.957,21.256,-11.233C27.537,-23.823,33.8,-36.494,38.416,-49.81C43.557,-64.64,46.239,-80.133,45.318,-95.846C45.25,-97.003,43.441,-97.011,43.509,-95.846C44.345,-81.583,42.221,-67.487,37.876,-53.905C33.571,-40.448,27.416,-27.683,21.142,-15.055C14.558,-1.803,8.022,11.452,-0.227,23.77C-7.702,34.933,-16.068,45.46,-23.865,56.394C-32.56,68.587,-40.514,81.396,-45.443,95.614C-45.825,96.717,-44.078,97.19,-43.698,96.095C-43.698,96.095,-43.698,96.095,-43.698,96.095Z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(502.351,752.554)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -6; 0; -6; 0; 0",
    keyTimes: "0; 0.257475; 0.498339; 0.755814; 0.996678; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i10",
    transform: "translate(-502.351,-752.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,472.351,655.092)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#015e95",
    d: "M70.849,97.536C66.99,66.748,52.777,37.35,31.042,15.205C15.154,-0.982,-4.422,-13.229,-20.028,-29.688C-37.994,-48.635,-50.2,-72.972,-54.642,-98.702C-74.94,-56.005,-76.245,-4.692,-58.145,38.982C-49.834,59.035,-37.632,77.618,-32.469,98.702"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i7",
    transform: "matrix(1,0,0,1,466.796,668.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1.146,-21.66C2.399,-7.267,0.978,7.274,0.169,21.656C0.104,22.814,-1.706,22.821,-1.64,21.656C-0.831,7.274,0.59,-7.267,-0.663,-21.66C-0.764,-22.82,1.046,-22.813,1.146,-21.66C1.146,-21.66,1.146,-21.66,1.146,-21.66Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,433.164,659.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M16.41,8.039C5.166,3.2,-6.079,-1.638,-17.323,-6.477C-18.39,-6.936,-17.469,-8.495,-16.41,-8.039C-5.166,-3.2,6.079,1.638,17.323,6.477C18.39,6.936,17.469,8.495,16.41,8.039C16.41,8.039,16.41,8.039,16.41,8.039Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,467.513,709.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M16.41,8.039C5.166,3.2,-6.079,-1.638,-17.323,-6.477C-18.39,-6.936,-17.469,-8.495,-16.41,-8.039C-5.166,-3.2,6.079,1.638,17.323,6.477C18.39,6.936,17.469,8.495,16.41,8.039C16.41,8.039,16.41,8.039,16.41,8.039Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,498.632,707.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M5.979,-21.636C4.076,-6.816,0.688,7.75,-4.189,21.875C-4.567,22.969,-6.316,22.499,-5.934,21.394C-1.113,7.431,2.288,-6.983,4.17,-21.636C4.316,-22.775,6.127,-22.79,5.979,-21.636C5.979,-21.636,5.979,-21.636,5.979,-21.636Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,460.711,658.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M43.698,96.095C34.679,70.08,15.686,49.512,0.352,27.171C-8.005,14.995,-14.676,1.957,-21.256,-11.233C-27.537,-23.823,-33.8,-36.494,-38.416,-49.81C-43.557,-64.64,-46.239,-80.133,-45.318,-95.846C-45.25,-97.003,-43.441,-97.011,-43.509,-95.846C-44.345,-81.583,-42.221,-67.487,-37.876,-53.905C-33.571,-40.448,-27.416,-27.683,-21.142,-15.055C-14.558,-1.803,-8.022,11.452,0.227,23.77C7.702,34.933,16.068,45.46,23.865,56.394C32.56,68.587,40.514,81.396,45.443,95.614C45.825,96.717,44.078,97.19,43.698,96.095C43.698,96.095,43.698,96.095,43.698,96.095Z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(589.351,673.554)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 6; 0; 6; 0; 0",
    keyTimes: "0; 0.257475; 0.498339; 0.755814; 0.996678; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    id: "i11",
    transform: "translate(-505.351,-751.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,472.351,655.092)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#015e95",
    d: "M70.849,97.536C66.99,66.748,52.777,37.35,31.042,15.205C15.154,-0.982,-4.422,-13.229,-20.028,-29.688C-37.994,-48.635,-50.2,-72.972,-54.642,-98.702C-74.94,-56.005,-76.245,-4.692,-58.145,38.982C-49.834,59.035,-37.632,77.618,-32.469,98.702"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i7",
    transform: "matrix(1,0,0,1,466.796,668.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1.146,-21.66C2.399,-7.267,0.978,7.274,0.169,21.656C0.104,22.814,-1.706,22.821,-1.64,21.656C-0.831,7.274,0.59,-7.267,-0.663,-21.66C-0.764,-22.82,1.046,-22.813,1.146,-21.66C1.146,-21.66,1.146,-21.66,1.146,-21.66Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,433.164,659.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M16.41,8.039C5.166,3.2,-6.079,-1.638,-17.323,-6.477C-18.39,-6.936,-17.469,-8.495,-16.41,-8.039C-5.166,-3.2,6.079,1.638,17.323,6.477C18.39,6.936,17.469,8.495,16.41,8.039C16.41,8.039,16.41,8.039,16.41,8.039Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,467.513,709.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M16.41,8.039C5.166,3.2,-6.079,-1.638,-17.323,-6.477C-18.39,-6.936,-17.469,-8.495,-16.41,-8.039C-5.166,-3.2,6.079,1.638,17.323,6.477C18.39,6.936,17.469,8.495,16.41,8.039C16.41,8.039,16.41,8.039,16.41,8.039Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,498.632,707.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M5.979,-21.636C4.076,-6.816,0.688,7.75,-4.189,21.875C-4.567,22.969,-6.316,22.499,-5.934,21.394C-1.113,7.431,2.288,-6.983,4.17,-21.636C4.316,-22.775,6.127,-22.79,5.979,-21.636C5.979,-21.636,5.979,-21.636,5.979,-21.636Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,460.711,658.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M43.698,96.095C34.679,70.08,15.686,49.512,0.352,27.171C-8.005,14.995,-14.676,1.957,-21.256,-11.233C-27.537,-23.823,-33.8,-36.494,-38.416,-49.81C-43.557,-64.64,-46.239,-80.133,-45.318,-95.846C-45.25,-97.003,-43.441,-97.011,-43.509,-95.846C-44.345,-81.583,-42.221,-67.487,-37.876,-53.905C-33.571,-40.448,-27.416,-27.683,-21.142,-15.055C-14.558,-1.803,-8.022,11.452,0.227,23.77C7.702,34.933,16.068,45.46,23.865,56.394C32.56,68.587,40.514,81.396,45.443,95.614C45.825,96.717,44.078,97.19,43.698,96.095C43.698,96.095,43.698,96.095,43.698,96.095Z"
  }))))))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.998,-0.067,0.067,0.998,497.89,270.517)",
    id: "i12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 2,
    stroke: "#606060",
    d: "M157.207,174.86"
  }, /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.5166666666666667s",
    to: "M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.5333333333333333s",
    to: "M-192.846,153.258C-191.984,153.909,-191.112,154.558,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.55s",
    to: "M-200.311,147.389C-197.099,150.018,-193.74,152.625,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.5666666666666667s",
    to: "M-211.812,137.304C-205.353,143.385,-198.177,149.361,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.5833333333333334s",
    to: "M-226.089,122.375C-216.445,133.644,-204.596,144.638,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.6s",
    to: "M-241.189,101.733C-229.815,120.237,-213.253,138.269,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.6166666666666667s",
    to: "M-254.189,74.64C-244.317,102.551,-224.381,130.082,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.6333333333333333s",
    to: "M-261.449,41.336C-257.91,80.307,-237.941,120.104,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.65s",
    to: "M-260.061,3.645C-267.987,53.837,-253.508,108.651,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.6666666666666666s",
    to: "M-249.224,-35.839C-272.249,23.559,-270.635,96.05,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.6833333333333333s",
    to: "M-229.733,-75.003C-268.7,-11.055,-289.427,82.224,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.7s",
    to: "M-202.583,-112.267C-253.876,-52.872,-311.145,66.245,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.7166666666666667s",
    to: "M-167.229,-144.677C-177.363,-137.606,-186.658,-129.53,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.7333333333333333s",
    to: "M-123.178,-167.116C-151.794,-157.032,-175.558,-141.315,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.75s",
    to: "M-73.875,-178.278C-125.638,-172.158,-165.238,-152.272,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.7666666666666667s",
    to: "M-22.663,-179.967C-100.4,-183.252,-156.044,-162.033,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.7833333333333333s",
    to: "M28.55,-174.732C-76.634,-191.172,-147.937,-170.64,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.8s",
    to: "M78.771,-164.419C74.749,-165.56,70.688,-166.586,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.8166666666666667s",
    to: "M125.479,-145.113C107.118,-155.305,87.311,-162.896,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.8333333333333334s",
    to: "M165.82,-116.459C137.678,-141.532,103.589,-159.283,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.85s",
    to: "M198.611,-81.341C193.441,-87.709,187.827,-94.194,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.8666666666666667s",
    to: "M225.094,-43.559C214.541,-61.534,200.338,-80.615,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.8833333333333333s",
    to: "M243.378,-3.816C233.892,-32.667,214.727,-64.997,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.9s",
    to: "M250.851,36.404C249.46,-1.56,231.026,-47.306,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.9166666666666666s",
    to: "M246.524,73.83C258.65,29.886,248.489,-28.351,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.9333333333333333s",
    to: "M233.166,105.176C260.11,59.179,265.826,-9.534,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.95s",
    to: "M215.499,129.483C254.471,85.109,282.215,8.255,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.9666666666666667s",
    to: "M197.338,147.485C243.056,107.756,297.505,24.851,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "0.9833333333333333s",
    to: "M181.109,160.247C226.977,127.617,311.828,40.397,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1s",
    to: "M168.344,168.659C206.996,145.181,325.362,55.086,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.0166666666666666s",
    to: "M160.107,173.372C183.623,160.832,338.259,69.086,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.018,61.924,-190.232,155.206M157.207,174.86",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.0333333333333334s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.05s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.0666666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.0833333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.1s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.1166666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.1333333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.15s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.1666666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.1833333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.2s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.2166666666666666s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.2333333333333334s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.25s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.2666666666666666s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.2833333333333334s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.3s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.3166666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.3333333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.35s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.3666666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.3833333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.4s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.4166666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.4333333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.45s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.4666666666666666s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.4833333333333334s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.5s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.5166666666666666s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.5333333333333334s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.55s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.5666666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.5833333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.6s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.6166666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.6333333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.65s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.6666666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.6833333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.7s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.7166666666666666s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.7333333333333334s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.75s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.7666666666666666s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.7833333333333334s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.8s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.8166666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.8333333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.85s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.8666666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.8833333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.9s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.9166666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.9333333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.95s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.9666666666666666s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "1.9833333333333334s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.0166666666666666s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.033333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.05s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.066666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.0833333333333335s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.1s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.1166666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.1333333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.15s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.1666666666666665s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.183333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.2s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.216666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.2333333333333334s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.25s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.2666666666666666s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.283333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.3s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.316666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.3333333333333335s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.35s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.3666666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.3833333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.4s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.4166666666666665s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.433333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.45s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.466666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.4833333333333334s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.5s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.5166666666666666s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.533333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.55s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.566666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.5833333333333335s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.6s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.6166666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.6333333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.65s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.6666666666666665s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.683333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.7s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.716666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.7333333333333334s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.75s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.7666666666666666s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.783333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.8s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.816666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.8333333333333335s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.85s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.8666666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.8833333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.9s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.9166666666666665s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.933333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.95s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.966666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "2.9833333333333334s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.0166666666666666s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.033333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.05s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.066666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.0833333333333335s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.1s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.1166666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.1333333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.15s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.1666666666666665s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.183333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.2s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.216666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.2333333333333334s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.25s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.2666666666666666s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.283333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.3s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.316666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.3333333333333335s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.35s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.3666666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.3833333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.4s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.4166666666666665s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.433333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.45s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.466666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.4833333333333334s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.5s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.5166666666666666s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.533333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.55s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.566666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.5833333333333335s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.6s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.6166666666666667s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.6333333333333333s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.65s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.6666666666666665s",
    to: "M157.207,174.86C157.207,174.86,350.643,82.526,181.742,-100.799C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.891,-64.517,-317.019,61.924,-190.231,155.207",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.683333333333333s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-247.473,-64.961,-315.923,59.922,-193.213,152.98",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.7s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-246.224,-66.287,-312.662,53.996,-201.68,146.259",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.716666666666667s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-244.106,-68.535,-307.177,44.131,-214.589,134.64",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.7333333333333334s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-241.023,-71.808,-299.286,30.176,-230.277,117.291",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.75s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-236.842,-76.248,-288.763,12.018,-246.088,93.138",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.7666666666666666s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-231.474,-81.947,-275.556,-9.992,-258.094,61.543",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.783333333333333s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-225.018,-88.802,-260.123,-34.528,-261.961,23.528",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.8s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-217.726,-96.544,-243.284,-59.699,-255.219,-18.071",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.816666666666667s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-209.708,-105.057,-225.492,-84.266,-238.072,-60.289",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.8333333333333335s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-59.745,-195.542,-142.451,-176.465,-195.171,-120.491C-200.616,-114.71,-206.236,-108.178,-211.796,-101.008",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.85s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-45.832,-192.453,-123.705,-180.095,-176.643,-137.628",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.8666666666666667s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C-17.242,-186.106,-81.863,-183.967,-131.259,-164.067",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.8833333333333333s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C9.547,-180.159,-38.6,-183.216,-79.109,-177.606",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.9s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C33.301,-174.886,3.043,-179.004,-24.437,-180.038",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.9166666666666665s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C151.001,-134.165,110.881,-157.664,66.59,-167.496C54.07,-170.275,41.979,-172.592,30.303,-174.456",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.933333333333333s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C155.042,-129.779,121.267,-151.315,83.83,-162.918",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.95s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C167.354,-116.416,150.911,-129.871,132.947,-140.775",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.966666666666667s",
    to: "M157.207,174.86C157.208,174.86,350.642,82.526,181.743,-100.798C179.348,-103.397,176.898,-105.935,174.393,-108.412",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "3.9833333333333334s",
    to: "M157.207,174.86C157.208,174.86,328.881,92.913,207.555,-69.856",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "4s",
    to: "M157.207,174.86C157.208,174.86,299.932,106.732,233.14,-28.672",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "4.016666666666667s",
    to: "M157.207,174.86C157.208,174.86,269.736,121.146,248.197,14.314",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "4.033333333333333s",
    to: "M157.207,174.86C157.207,174.86,240.223,135.233,250,56.358",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "4.05s",
    to: "M157.207,174.86C157.207,174.86,214.48,147.521,239.486,93.061",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "4.066666666666666s",
    to: "M157.207,174.86C157.207,174.86,194.292,157.158,221.808,121.867",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "4.083333333333333s",
    to: "M157.207,174.86C157.207,174.86,179.432,164.251,202.237,143.086",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "4.1s",
    to: "M157.207,174.86C157.207,174.86,169.002,169.23,184.224,157.99",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "4.116666666666666s",
    to: "M157.207,174.86C157.207,174.86,162.189,172.482,169.857,167.731",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "4.133333333333334s",
    to: "M157.207,174.86C157.207,174.86,158.398,174.291,160.512,173.155",
    attributeName: "d"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    dur: "0.017s",
    begin: "4.15s",
    to: "M157.207,174.86",
    attributeName: "d"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    visibility: "hidden",
    id: "i13"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "5.017s",
    values: "hidden; visible; visible",
    keyTimes: "0; 0.063004; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(698.793,191.983)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 0 0; 1 1; 1 1; 0 0; 0 0",
    keyTimes: "0; 0.142857; 0.182724; 0.790698; 0.830565; 1",
    keySplines: "0 0 1 1; 0.333 0 0.09 1; 0 0 1 1; 0.91 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-784.793,-431.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,784.793,431.983)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#015e95",
    d: "M49.117,0C49.117,27.127,27.127,49.117,0,49.117C-27.127,49.117,-49.117,27.127,-49.117,0C-49.117,-27.127,-27.127,-49.117,0,-49.117C27.127,-49.117,49.117,-27.127,49.117,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,786.982,431.983)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8e9f0",
    d: "M-3.833,30.869C1.984,29.325,7.012,25.947,9.7,20.964C9.823,20.735,10.977,18.626,10.942,18.395C14.065,12.38,13.808,2.399,13.577,-0.934C13.373,-10.189,10.873,-16.815,8.58,-20.338C8.601,-20.694,7.212,-22.691,6.93,-22.995C1.569,-28.779,-2.334,-30.328,-8.344,-31.046C-11.13,-31.379,-13.829,-29.895,-13.698,-28.126C-13.698,-28.126,-12.409,-10.78,-12.409,-10.78C-12.279,-9.037,-9.45,-7.98,-6.773,-8.691C-4.296,-9.348,-1.361,-10.361,1.16,-11.856C2.28,-8.937,3.213,-5.1,3.31,-0.286C3.31,-0.286,3.316,-0.161,3.316,-0.161C3.56,3.297,3.408,7.256,2.903,10.535C0.2,9.411,-2.849,8.819,-5.404,8.514C-8.19,8.181,-10.889,9.665,-10.758,11.434C-10.758,11.434,-9.469,28.78,-9.469,28.78C-9.339,30.523,-6.51,31.58,-3.833,30.869Z"
  }))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    visibility: "hidden",
    id: "i6"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "5.017s",
    values: "hidden; visible; visible",
    keyTimes: "0; 0.037002; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(484.432,91.892)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 0 0; 1 1; 1 1; 0 0; 0 0",
    keyTimes: "0; 0.116279; 0.156146; 0.76412; 0.803987; 1",
    keySplines: "0 0 1 1; 0.333 0 0.09 1; 0 0 1 1; 0.91 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-570.432,-331.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,570.432,331.892)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#015e95",
    d: "M35.457,0C35.457,19.583,19.583,35.457,0,35.457C-19.583,35.457,-35.457,19.583,-35.457,0C-35.457,-19.583,-19.583,-35.457,0,-35.457C19.583,-35.457,35.457,-19.583,35.457,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,570.432,331.892)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8e9f0",
    d: "M14.15,-6.385C14.15,-14.59,7.815,-21.241,0,-21.241C-7.815,-21.241,-14.15,-14.59,-14.15,-6.385C-14.15,-4.619,-13.841,-2.933,-13.303,-1.362C-13.303,-1.362,-13.319,-1.363,-13.319,-1.363C-13.319,-1.363,-13.247,-1.204,-13.247,-1.204C-12.962,-0.402,-12.617,0.367,-12.21,1.097C-12.21,1.097,0.496,21.241,0.496,21.241C0.496,21.241,12.805,-0.062,12.805,-0.062C12.805,-0.062,12.79,-0.062,12.79,-0.062C13.653,-1.983,14.15,-4.12,14.15,-6.385ZM0.417,0C-3.34,0,-6.385,-3.046,-6.385,-6.803C-6.385,-10.56,-3.34,-13.605,0.417,-13.605C4.174,-13.605,7.219,-10.56,7.219,-6.803C7.219,-3.046,4.174,0,0.417,0Z"
  }))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    visibility: "hidden",
    id: "i10"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    begin: "0s",
    calcMode: "discrete",
    dur: "5.017s",
    values: "hidden; visible; visible",
    keyTimes: "0; 0.020001; 1",
    attributeName: "visibility"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(298.026,157.834)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0,0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0 0; 0 0; 1 1; 1 1; 0 0; 0 0",
    keyTimes: "0; 0.099668; 0.139535; 0.747508; 0.787375; 1",
    keySplines: "0 0 1 1; 0.333 0 0.09 1; 0 0 1 1; 0.91 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-384.026,-397.834)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,384.026,397.834)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#015e95",
    d: "M29.299,21.167C34.448,14.742,37.535,6.592,37.535,-2.283C37.535,-23.013,20.73,-39.818,0,-39.818C-20.73,-39.818,-37.535,-23.013,-37.535,-2.283C-37.535,18.447,-20.73,35.252,0,35.252C4.758,35.252,9.304,34.358,13.493,32.743C13.493,32.743,13.477,32.755,13.477,32.755C13.477,32.755,32.146,39.818,32.146,39.818C32.146,39.818,29.318,21.153,29.318,21.153C29.318,21.153,29.299,21.167,29.299,21.167Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,369.837,397.086)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8e9f0",
    d: "M3.061,0C3.061,1.69,1.69,3.061,0,3.061C-1.69,3.061,-3.061,1.69,-3.061,0C-3.061,-1.69,-1.69,-3.061,0,-3.061C1.69,-3.061,3.061,-1.69,3.061,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,383.278,397.086)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8e9f0",
    d: "M3.061,0C3.061,1.69,1.69,3.061,0,3.061C-1.69,3.061,-3.061,1.69,-3.061,0C-3.061,-1.69,-1.69,-3.061,0,-3.061C1.69,-3.061,3.061,-1.69,3.061,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,396.72,397.086)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c8e9f0",
    d: "M3.061,0C3.061,1.69,1.69,3.061,0,3.061C-1.69,3.061,-3.061,1.69,-3.061,0C-3.061,-1.69,-1.69,-3.061,0,-3.061C1.69,-3.061,3.061,-1.69,3.061,0Z"
  })))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(507.814,280.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -12; -12; 0; 0; -12; 0; 0",
    keyTimes: "0; 0.109635; 0.395349; 0.504984; 0.740863; 0.850498; 0.996678; 1",
    keySplines: "0.333 0 0.667 1; 0.298 0 0.667 1; 0.333 0 0.667 1; 0.298 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-593.814,-520.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i14",
    transform: "matrix(1,0,0,1,503.391,480.43)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M5.443,-14.184C5.206,-15.439,5.008,-16.702,4.86,-17.97C4.794,-18.242,4.731,-18.515,4.654,-18.787C4.654,-18.787,4.776,-18.721,4.776,-18.721C4.753,-18.949,4.739,-19.176,4.718,-19.404C-1.26,-15.653,-5.502,-6.229,-5.502,4.813C-5.502,10.223,-4.483,15.246,-2.741,19.404C-2.674,19.022,-2.621,18.637,-2.543,18.257C-0.281,7.318,6.182,-3.434,5.443,-14.184Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i15",
    transform: "matrix(1,0,0,1,514.619,502.694)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M3.356,-8.506C1.536,-3.914,-0.928,0.462,-2.498,5.159C-2.828,6.147,-3.109,7.149,-3.356,8.16C-2.512,8.384,-1.647,8.506,-0.764,8.506C-0.672,8.506,-0.581,8.498,-0.49,8.495C0.072,3.866,1.58,-0.686,2.662,-5.256C2.917,-6.334,3.147,-7.418,3.356,-8.506Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i16",
    transform: "matrix(1,0,0,1,535.049,522.806)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M21.024,18.82C20.969,18.272,20.903,17.674,20.823,17.047C20.765,16.62,20.719,16.192,20.644,15.768C20.638,15.727,20.63,15.685,20.624,15.644C20.604,15.534,20.573,15.427,20.552,15.318C20.358,15.289,20.175,15.277,19.975,15.239C14.619,14.23,11.496,10.405,7.335,6.884C3.056,3.263,-2.151,-4.091,-4.387,-8.87C-6.244,-12.84,-6.972,-16.722,-7.301,-20.641C-7.319,-20.732,-7.34,-20.821,-7.356,-20.913C-7.532,-21.944,-7.573,-22.946,-7.5,-23.876C-7.504,-23.979,-7.507,-24.082,-7.511,-24.185C-10.261,-16.767,-15.228,-11.772,-20.921,-11.616C-21.109,-10.071,-21.191,-8.517,-21.117,-6.951C-20.681,2.267,-14.69,10.593,-6.976,15.659C0.738,20.725,9.992,22.923,19.158,23.996C19.786,24.069,20.42,24.132,21.057,24.185C21.181,22.397,21.173,20.603,21.024,18.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i17",
    transform: "matrix(1,0,0,1,520.833,499.343)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M6.705,-0.722C6.629,-2.727,6.597,-4.753,6.525,-6.814C3.999,-7.979,1.441,-9.759,-0.876,-11.847C-0.983,-11.265,-1.099,-10.685,-1.24,-10.107C-1.653,-8.413,-2.218,-6.771,-2.859,-5.154C-3.068,-4.066,-3.298,-2.982,-3.553,-1.904C-4.635,2.666,-6.143,7.218,-6.705,11.847C-1.012,11.691,3.955,6.696,6.705,-0.722Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i18",
    transform: "matrix(1,0,0,1,560.221,544.364)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc3c5",
    d: "M4.147,1.704C0.85,2.042,-1.064,1.962,-3.93,-0.028C-3.93,-0.028,-3.99,-1.163,-4.147,-2.738C-3.998,-0.955,-3.991,0.838,-4.115,2.626C-1.289,2.862,1.58,2.801,4.147,1.704Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i19",
    transform: "matrix(1,0,0,1,577.091,534.232)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9798",
    d: "M-10.904,2.322C-13.242,2.917,-15.153,3.553,-17.127,3.865C-17.127,3.865,-12.373,11.698,-12.373,11.698C-12.487,11.752,-12.607,11.788,-12.723,11.837C-12.253,11.789,-11.754,11.732,-11.221,11.671C-7.799,11.281,-4.835,9.804,-1.627,8.314C0.34,7.401,5.848,4.218,7.507,2.65C9.551,0.718,13.939,-4.574,15.324,-6.081C15.781,-6.578,16.189,-7.045,16.571,-7.497C16.612,-8.924,16.781,-10.356,17.127,-11.837C8.711,-5.119,-2.828,0.268,-10.904,2.322Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i20",
    transform: "matrix(1,0,0,1,560.169,542.159)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9798",
    d: "M-0.206,-4.062C-1.566,-3.847,-2.967,-3.8,-4.549,-4.033C-4.531,-3.925,-4.513,-3.818,-4.496,-3.71C-4.489,-3.669,-4.483,-3.626,-4.476,-3.585C-4.41,-3.152,-4.351,-2.725,-4.297,-2.306C-4.216,-1.716,-4.146,-1.126,-4.096,-0.533C-3.939,1.042,-3.878,2.177,-3.878,2.177C-1.012,4.167,0.902,4.247,4.199,3.909C4.315,3.86,4.435,3.824,4.549,3.77C4.549,3.77,-0.206,-4.062,-0.206,-4.062Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i21",
    transform: "matrix(1,0,0,1,506.695,517.654)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-6.044,-17.819C-8.339,-4.731,-3.933,9.792,6.636,17.819C3.292,10.131,2.582,1.341,4.568,-6.799C0.165,-7.968,-3.633,-12.063,-6.044,-17.819Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i22",
    transform: "matrix(1,0,0,1,508.149,462.052)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.103,-0.409C-0.026,-0.137,0.037,0.137,0.103,0.409C0.074,0.159,0.045,-0.091,0.019,-0.342C0.019,-0.342,-0.103,-0.409,-0.103,-0.409Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i23",
    transform: "matrix(1,0,0,1,509.84,488.55)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M8.134,5.638C8.614,3.136,8.959,0.61,9.19,-1.927C6.035,-4.966,3.423,-8.507,2.125,-11.672C0.723,-15.091,-0.319,-18.665,-1.006,-22.304C-0.267,-11.554,-6.731,-0.802,-8.993,10.137C-9.071,10.517,-9.123,10.902,-9.19,11.284C-6.779,17.04,-2.981,21.135,1.422,22.304C1.669,21.293,1.95,20.291,2.28,19.303C3.85,14.606,6.314,10.23,8.134,5.638Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i24",
    transform: "matrix(1,0,0,1,518.966,490.406)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.991,3.783C-0.35,2.166,0.214,0.524,0.627,-1.17C0.768,-1.748,0.884,-2.328,0.991,-2.91C0.676,-3.194,0.371,-3.489,0.065,-3.783C-0.166,-1.246,-0.511,1.281,-0.991,3.783Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i25",
    transform: "matrix(1,0,0,1,606.506,460.399)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M51.209,23.36C49.691,15.539,45.462,6.215,41.207,-0.52C31.953,-15.168,26.872,-32.521,15.311,-45.426C0.399,-62.071,-33.213,-68.694,-52.233,-55.728C-52.109,-55.728,-51.983,-55.725,-51.858,-55.724C-46.738,-56.766,-41.49,-57.073,-36.29,-56.463C-31.7,-55.925,-27.18,-54.622,-22.981,-52.662C-15.802,-53.006,-8.523,-51.362,-2.233,-47.877C3.056,-44.947,7.621,-40.784,11.288,-35.976C13.471,-33.113,15.342,-30.025,17.084,-26.874C27.308,-8.377,34.71,12.07,36.036,33.038C41.972,40.722,43.152,52.15,36.816,62.562C51.044,54.455,54.187,38.697,51.209,23.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i26",
    transform: "matrix(1,0,0,1,583.612,517.142)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M-14.494,8.382C-14.494,8.382,13.488,-5.176,13.488,-5.176C13.822,-6.213,14.16,-7.276,14.494,-8.382C5.668,-2.355,-3.862,2.691,-13.802,6.544C-13.804,7.144,-14.052,7.776,-14.494,8.382Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i27",
    transform: "matrix(1,0,0,1,524.895,466.605)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M0.309,0.385C0.115,0.066,-0.084,-0.247,-0.288,-0.549C-0.301,-0.185,-0.304,0.181,-0.309,0.549C-0.105,0.49,0.103,0.439,0.309,0.385Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i28",
    transform: "matrix(1,0,0,1,527.212,478.761)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M2.609,6.483C2.609,0.452,1.34,-5.094,-0.782,-9.501C-1.014,-9.447,-1.247,-9.401,-1.477,-9.342C-1.855,-9.245,-2.233,-9.133,-2.609,-9.014C-2.55,-6.978,-2.399,-4.994,-2.189,-3.28C-1.846,-0.487,-0.951,2.609,0.166,5.659C0.166,5.659,2.498,9.501,2.498,9.501C2.569,8.51,2.609,7.505,2.609,6.483Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i29",
    transform: "matrix(1,0,0,1,527.57,498.684)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M-0.032,-0.064C-0.028,0.039,-0.025,0.142,-0.021,0.245C-0.008,0.078,0.012,-0.083,0.032,-0.245C0.01,-0.185,-0.01,-0.124,-0.032,-0.064Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i30",
    transform: "matrix(1,0,0,1,531.625,491.531)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M-2.054,-1.734C-1.435,-0.35,-0.808,0.975,-0.205,2.199C0.576,2.248,1.35,2.629,2.054,3.269C2.054,3.269,-1.915,-3.269,-1.915,-3.269C-1.952,-2.752,-1.999,-2.241,-2.054,-1.734Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i31",
    transform: "matrix(1,0,0,1,561.312,492.955)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M28.755,-7.712C28.755,-13.674,30.318,-19.163,32.94,-23.545C30.12,-23.286,27.301,-22.982,24.487,-22.644C18.116,-21.878,9.229,-24.133,1.469,-27.855C1.001,-27.69,0.536,-27.521,0.078,-27.342C-1.125,-26.873,-1.774,-28.336,-1.216,-29.228C-5.992,-31.825,-10.129,-34.949,-12.658,-38.199C-15.244,-41.523,-18.278,-46.243,-22.286,-44.949C-23.404,-44.588,-24.312,-43.775,-25.159,-42.961C-29.703,-38.595,-33.58,-33.54,-36.647,-28.035C-36.669,-27.659,-36.693,-27.283,-36.706,-26.9C-36.502,-26.598,-36.303,-26.285,-36.109,-25.966C-31.796,-27.103,-27.054,-27.311,-22.661,-26.899C-21.076,-26.75,-21.066,-24.258,-22.661,-24.408C-26.69,-24.786,-30.919,-24.613,-34.883,-23.695C-32.761,-19.288,-31.492,-13.743,-31.492,-7.712C-31.492,-6.69,-31.532,-5.685,-31.603,-4.694C-31.603,-4.694,-27.633,1.845,-27.633,1.845C-26.69,2.702,-25.877,4.017,-25.347,5.611C-25.154,6.192,-24.994,6.804,-24.884,7.449C-24.188,11.533,-25.58,15.177,-27.992,15.588C-30.349,15.99,-32.804,13.151,-33.564,9.209C-33.235,13.128,-32.507,17.01,-30.65,20.98C-28.414,25.759,-23.207,33.113,-18.928,36.734C-14.767,40.255,-11.644,44.08,-6.288,45.089C-6.088,45.127,-5.905,45.139,-5.711,45.168C-6.036,43.458,-6.498,41.776,-7.094,40.138C-7.144,40.046,-7.191,39.943,-7.243,39.861C-7.243,39.861,-7.21,39.844,-7.21,39.844C-7.417,39.293,-7.619,38.741,-7.857,38.201C-7.857,38.201,-5.9,37.645,-5.9,37.645C-5.9,37.645,1.124,35.649,1.124,35.649C-0.553,35.626,-1.888,35.014,-2.292,33.904C-2.925,32.168,-1.049,29.89,1.897,28.816C3.804,28.121,5.681,28.109,6.947,28.652C11.483,26.923,15.919,24.95,20.236,22.725C25.837,19.838,31.426,16.595,36.706,12.949C31.875,8.207,28.755,0.719,28.755,-7.712ZM-19.474,2.878C-16.644,-3.578,-16.324,-7.827,-15.546,-13.438C-12.94,-7.391,-11.247,-0.656,-10.593,6.255C-13.259,6.397,-15.942,5.983,-18.512,5.033C-18.843,4.911,-19.197,4.755,-19.389,4.378C-19.606,3.951,-19.679,3.346,-19.474,2.878ZM-27.388,-9.229C-28.805,-9.229,-29.954,-10.692,-29.954,-12.497C-29.954,-14.302,-28.805,-15.766,-27.388,-15.766C-25.971,-15.766,-24.821,-14.302,-24.821,-12.497C-24.821,-10.692,-25.971,-9.229,-27.388,-9.229ZM-6.715,26.231C-9.269,26.586,-11.422,26.272,-13.228,25.574C-19.51,23.148,-21.578,16.052,-21.578,16.052C-21.578,16.052,-19.177,15.774,-19.177,15.774C-19.177,15.774,9.001,12.514,9.001,12.514C9.001,12.514,1.734,25.058,-6.715,26.231ZM8.736,-12.448C7.319,-12.448,6.17,-13.912,6.17,-15.717C6.17,-17.522,7.319,-18.985,8.736,-18.985C10.153,-18.985,11.303,-17.522,11.303,-15.717C11.303,-13.912,10.153,-12.448,8.736,-12.448ZM19.392,8.906C15.249,8.906,11.89,5.548,11.89,1.405C11.89,-2.738,15.249,-6.096,19.392,-6.096C23.535,-6.096,26.893,-2.738,26.893,1.405C26.893,5.548,23.535,8.906,19.392,8.906Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i32",
    transform: "matrix(1,0,0,1,529.746,494.381)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M-1.238,1.173C-0.671,0.192,0.113,-0.466,1.055,-0.627C1.116,-0.637,1.177,-0.636,1.238,-0.642C0.603,-0.769,-0.042,-0.946,-0.695,-1.173C-0.853,-0.374,-1.035,0.41,-1.238,1.173Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i33",
    transform: "matrix(1,0,0,1,528.205,495.575)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M0.304,-0.021C0.507,-0.784,0.689,-1.568,0.847,-2.367C0.286,-2.562,-0.279,-2.784,-0.847,-3.046C-0.775,-0.985,-0.743,1.041,-0.667,3.046C-0.645,2.986,-0.624,2.924,-0.602,2.864C-0.461,1.75,-0.149,0.762,0.304,-0.021Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i34",
    transform: "matrix(1,0,0,1,528.543,487.108)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M-1.166,-2.689C-0.493,-0.853,0.255,0.963,1.027,2.689C1.082,2.182,1.129,1.67,1.166,1.153C1.166,1.153,-1.166,-2.689,-1.166,-2.689Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i35",
    transform: "matrix(1,0,0,1,559.101,530.2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M3.689,-1.609C3.571,-1.605,3.45,-1.593,3.335,-1.595C3.335,-1.595,-3.689,0.4,-3.689,0.4C-3.689,0.4,-2.955,1.609,-2.955,1.609C-2.955,1.609,3.689,-1.609,3.689,-1.609Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i36",
    transform: "matrix(1,0,0,1,554.801,531.7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M0.611,-1.1C0.611,-1.1,-1.345,-0.544,-1.345,-0.544C-1.107,-0.004,-0.906,0.549,-0.699,1.1C-0.699,1.1,1.345,0.11,1.345,0.11C1.345,0.11,0.611,-1.1,0.611,-1.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i37",
    transform: "matrix(1,0,0,1,554.919,535.61)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M-0.701,-2.516C-0.105,-0.878,0.357,0.803,0.682,2.513C0.688,2.514,0.695,2.515,0.701,2.516C0.384,0.576,-0.069,-1.345,-0.701,-2.516Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i38",
    transform: "matrix(1,0,0,1,582.128,519.615)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M-14.972,7.649C-14.972,7.649,12.732,-0.221,12.732,-0.221C13.343,-2.672,14.142,-5.077,14.972,-7.649C14.972,-7.649,-13.01,5.909,-13.01,5.909C-13.471,6.541,-14.143,7.144,-14.972,7.649Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i39",
    transform: "matrix(1,0,0,1,554.144,532.947)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M-0.074,-0.131C-0.022,-0.049,0.024,0.055,0.074,0.147C0.038,0.048,-0.004,-0.049,-0.041,-0.147C-0.041,-0.147,-0.074,-0.131,-0.074,-0.131Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i40",
    transform: "matrix(1,0,0,1,575.503,528.746)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M-10.002,-0.686C-10.937,-0.345,-11.858,-0.184,-12.713,-0.155C-12.713,-0.155,-19.357,3.064,-19.357,3.064C-19.357,3.064,-15.54,9.352,-15.54,9.352C-13.566,9.04,-11.655,8.403,-9.317,7.808C-1.241,5.754,10.299,0.368,18.715,-6.35C18.723,-6.384,18.728,-6.418,18.736,-6.452C18.907,-7.435,19.119,-8.397,19.357,-9.352C19.357,-9.352,-8.347,-1.482,-8.347,-1.482C-8.847,-1.177,-9.4,-0.905,-10.002,-0.686Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i41",
    transform: "matrix(1,0,0,1,557.033,535.045)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M-2.93,-2.245C-2.893,-2.147,-2.851,-2.05,-2.815,-1.951C-2.183,-0.78,-1.73,1.141,-1.413,3.081C0.169,3.314,1.57,3.267,2.93,3.052C2.93,3.052,-0.887,-3.235,-0.887,-3.235C-0.887,-3.235,-2.93,-2.245,-2.93,-2.245Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i42",
    transform: "matrix(1,0,0,1,538.101,438.584)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9798",
    d: "M-0.233,-0.868C-0.518,-0.428,-0.809,0.009,-1.104,0.445C-1.104,0.445,1.104,0.868,1.104,0.868C0.662,0.284,0.217,-0.296,-0.233,-0.868Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i43",
    transform: "matrix(1,0,0,1,582.213,447.074)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9798",
    d: "M-0.465,0.529C-0.465,0.529,0.562,0.726,0.562,0.726C0.183,0.245,-0.2,-0.232,-0.562,-0.726C-0.557,-0.305,-0.52,0.113,-0.465,0.529Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i44",
    transform: "matrix(1,0,0,1,580.111,459.031)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9798",
    d: "M12.804,-1.319C9.019,-4.176,5.598,-7.507,2.664,-11.232C2.664,-11.232,1.637,-11.429,1.637,-11.429C2.533,-4.619,9.831,1.535,14.852,6.25C12.592,7.364,1.465,8.817,-1.031,8.471C-6.043,7.777,-10.143,6.712,-14.046,5.059C-15.158,5.351,-16.256,5.691,-17.33,6.069C-9.57,9.791,-0.683,12.046,5.688,11.28C8.502,10.942,11.321,10.638,14.141,10.379C15.077,8.814,16.146,7.388,17.33,6.135C15.834,2.744,14.169,0.316,12.804,-1.319Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i45",
    transform: "matrix(1,0,0,1,543.685,451.975)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9798",
    d: "M17.043,11.237C17.69,10.985,18.352,10.75,19.02,10.525C16.632,9.273,14.241,7.77,11.678,5.952C5.043,1.247,0.491,-5.955,-4.48,-12.523C-4.48,-12.523,-6.688,-12.946,-6.688,-12.946C-11.303,-6.117,-16.929,0.312,-18.552,8.837C-18.789,10.084,-18.935,11.487,-19.02,12.946C-15.953,7.441,-12.076,2.386,-7.532,-1.98C-6.685,-2.794,-5.777,-3.607,-4.659,-3.968C-0.651,-5.262,2.384,-0.542,4.97,2.782C7.499,6.032,11.636,9.156,16.412,11.753C16.548,11.535,16.753,11.35,17.043,11.237Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i46",
    transform: "matrix(1,0,0,1,520.136,452.441)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M1.489,5.259C1.489,5.259,1.48,-4.305,1.48,-4.305C1.184,-6.036,1.324,-7.735,1.757,-9.39C0.84,-6.455,0.088,-3.468,-0.496,-0.45C-0.853,1.392,-1.147,3.244,-1.41,5.102C-1.421,5.178,-1.428,5.228,-1.433,5.265C-1.437,5.301,-1.444,5.348,-1.453,5.42C-1.477,5.611,-1.502,5.802,-1.526,5.993C-1.569,6.33,-1.61,6.666,-1.651,7.003C-1.687,7.305,-1.722,7.607,-1.757,7.909C-0.936,8.303,-0.14,8.796,0.62,9.39C0.652,9.024,0.683,8.659,0.744,8.291C0.909,7.295,1.161,6.28,1.489,5.259Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i47",
    transform: "matrix(1,0,0,1,526.239,435.196)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M3.963,-5.489C3.468,-5.883,2.956,-6.255,2.437,-6.617C0.38,-3.604,-1.321,-0.354,-2.647,2.982C-3.123,4.18,-3.557,5.394,-3.963,6.617C-2.817,3.36,-0.627,0.295,1.534,-2.466C2.323,-3.474,3.134,-4.485,3.963,-5.489Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i48",
    transform: "matrix(1,0,0,1,531.082,432.848)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-16.974,26.448C-15.857,17.245,-13.854,8.152,-9.809,-0.245C-8.759,-2.426,-7.557,-4.512,-6.221,-6.487C-6.386,-6.565,-6.546,-6.648,-6.713,-6.722C-6.713,-6.722,-8.376,-6.671,-8.376,-6.671C-6.695,-12.157,-2.11,-16.247,2.676,-19.412C8.853,-23.496,15.812,-26.521,23.041,-28.067C23.041,-28.067,23.033,-28.076,23.033,-28.076C23.085,-28.112,23.139,-28.142,23.191,-28.177C-3.794,-28.132,-14.223,-8.085,-19.414,4.177C-22.605,11.715,-23.708,20.015,-22.972,28.177C-21.189,27.058,-19.253,26.438,-17.227,26.438C-17.142,26.438,-17.058,26.446,-16.974,26.448Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i49",
    transform: "matrix(1,0,0,1,508.543,464.353)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.292,1.893C0.205,0.631,0.012,-0.631,-0.292,-1.893C-0.144,-0.625,0.055,0.638,0.292,1.893Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i50",
    transform: "matrix(1,0,0,1,514.756,464.259)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M4.699,3.578C4.759,4.042,4.82,4.506,4.879,4.972C5.442,4.628,6.03,4.31,6.647,4.034C6.095,1.91,5.808,-0.241,6,-2.427C5.24,-3.021,4.444,-3.514,3.623,-3.908C3.584,-3.575,3.545,-3.242,3.506,-2.909C3.369,-1.724,2.61,-0.71,1.308,-0.71C0.218,-0.71,-1.028,-1.727,-0.891,-2.909C-0.818,-3.544,-0.745,-4.179,-0.669,-4.814C-0.663,-4.863,-0.655,-4.913,-0.649,-4.962C-0.733,-4.964,-0.816,-4.972,-0.901,-4.972C-2.927,-4.972,-4.864,-4.352,-6.647,-3.233C-6.626,-3.005,-6.612,-2.777,-6.589,-2.549C-6.589,-2.549,4.699,3.578,4.699,3.578Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i51",
    transform: "matrix(1,0,0,1,523.166,476.726)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-1.449,-5.799C-1.474,-5.739,-1.504,-5.682,-1.529,-5.622C-1.529,-5.622,-1.529,-5.756,-1.529,-5.756C-1.806,-5.612,-2.085,-5.47,-2.351,-5.311C-2.658,-5.128,-2.93,-4.917,-3.189,-4.695C-3.18,-4.614,-3.171,-4.534,-3.162,-4.453C-3.162,-4.453,3.189,6.01,3.189,6.01C2.316,2.054,0.344,-1.934,-1.032,-6.01C-1.173,-5.943,-1.31,-5.87,-1.449,-5.799Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i52",
    transform: "matrix(1,0,0,1,523.657,482.401)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M2.697,0.335C2.697,0.335,-3.654,-10.128,-3.654,-10.128C-3.08,-5.032,-2.787,0.105,-3.7,5.095C-1.383,7.183,1.174,8.963,3.7,10.128C3.601,7.277,3.42,4.359,2.902,1.326C2.846,0.996,2.77,0.666,2.697,0.335Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i53",
    transform: "matrix(1,0,0,1,519.948,472.151)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.055,-0.06C-0.055,-0.06,0.055,0.121,0.055,0.121C0.046,0.04,0.037,-0.04,0.028,-0.121C0.002,-0.099,-0.03,-0.082,-0.055,-0.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i54",
    transform: "matrix(1,0,0,1,513.901,474.166)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M5.171,-1.201C4.703,-0.598,4.33,0.086,4.018,0.827C3.405,2.285,0.995,1.64,1.616,0.165C2.4,-1.698,3.378,-3.328,5.055,-4.514C5.269,-4.665,5.506,-4.797,5.734,-4.936C5.675,-5.402,5.614,-5.866,5.554,-6.33C5.554,-6.33,-5.734,-12.457,-5.734,-12.457C-5.708,-12.206,-5.679,-11.956,-5.65,-11.706C-5.346,-10.444,-5.154,-9.182,-5.067,-7.92C-4.38,-4.281,-3.338,-0.707,-1.936,2.712C-0.638,5.877,1.974,9.418,5.129,12.457C5.543,7.917,5.558,3.342,5.171,-1.201Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i55",
    transform: "matrix(1,0,0,1,519.786,479.794)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.217,-7.521C0.217,-7.521,0.107,-7.702,0.107,-7.702C-0.195,-7.434,-0.469,-7.143,-0.714,-6.828C-0.327,-2.285,-0.342,2.29,-0.756,6.83C-0.45,7.124,-0.144,7.418,0.171,7.702C1.084,2.712,0.791,-2.425,0.217,-7.521Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i56",
    transform: "matrix(1,0,0,1,554.381,404.726)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.259,0.055C-0.084,0.018,0.092,-0.015,0.267,-0.051C0.142,-0.052,0.016,-0.055,-0.108,-0.055C-0.16,-0.02,-0.215,0.011,-0.267,0.047C-0.267,0.047,-0.259,0.055,-0.259,0.055Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i57",
    transform: "matrix(1,0,0,1,521.193,460.136)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.432,-2.436C0.104,-1.415,-0.148,-0.4,-0.313,0.596C-0.374,0.964,-0.404,1.329,-0.436,1.695C-0.139,1.927,0.15,2.176,0.436,2.436C0.436,2.436,0.432,-2.436,0.432,-2.436Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i58",
    transform: "matrix(1,0,0,1,524.476,465.488)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.13,0.568C0.143,0.185,0.167,-0.192,0.189,-0.568C0.062,-0.341,-0.065,-0.113,-0.189,0.116C-0.082,0.266,0.026,0.414,0.13,0.568Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i59",
    transform: "matrix(1,0,0,1,524.756,477.083)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.153,-7.337C-0.994,-7.071,-1.824,-6.747,-2.622,-6.367C-1.246,-2.291,0.726,1.696,1.599,5.652C1.599,5.652,2.622,7.337,2.622,7.337C1.505,4.287,0.61,1.19,0.267,-1.603C0.057,-3.317,-0.094,-5.301,-0.153,-7.337Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i60",
    transform: "matrix(1,0,0,1,521.165,465.062)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.464,-2.489C0.178,-2.749,-0.112,-2.999,-0.409,-3.231C-0.601,-1.045,-0.314,1.107,0.238,3.231C0.315,3.197,0.391,3.162,0.469,3.129C0.469,3.129,0.464,-2.489,0.464,-2.489Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i61",
    transform: "matrix(1,0,0,1,523.941,466.584)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.665,0.98C-0.337,0.868,-0.008,0.755,0.315,0.658C0.423,0.625,0.536,0.601,0.645,0.57C0.65,0.202,0.652,-0.165,0.665,-0.529C0.561,-0.683,0.453,-0.83,0.346,-0.98C-0.004,-0.333,-0.338,0.321,-0.665,0.98Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i62",
    transform: "matrix(1,0,0,1,530.236,491.768)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-1.184,1.441C-0.531,1.668,0.114,1.844,0.749,1.971C0.894,1.957,1.039,1.953,1.184,1.962C0.581,0.738,-0.046,-0.587,-0.665,-1.971C-0.792,-0.805,-0.965,0.335,-1.184,1.441Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i63",
    transform: "matrix(1,0,0,1,527.963,487.972)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M1.608,1.825C0.836,0.099,0.088,-1.716,-0.585,-3.552C-0.585,-3.552,-1.608,-5.236,-1.608,-5.236C-1.535,-4.905,-1.46,-4.575,-1.404,-4.245C-0.886,-1.212,-0.704,1.706,-0.605,4.557C-0.037,4.819,0.528,5.041,1.089,5.236C1.308,4.13,1.481,2.991,1.608,1.825Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i64",
    transform: "matrix(1,0,0,1,529.663,443.703)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M6.088,-4.913C6.088,-4.913,7.333,-4.675,7.333,-4.675C7.628,-5.111,7.92,-5.548,8.205,-5.988C5.868,-8.954,3.395,-11.727,0.539,-13.997C-0.29,-12.993,-1.102,-11.981,-1.891,-10.973C-4.052,-8.212,-6.242,-5.147,-7.388,-1.89C-7.524,-1.48,-7.642,-1.064,-7.771,-0.652C-8.204,1.003,-8.344,2.702,-8.048,4.433C-8.048,4.433,-8.039,13.997,-8.039,13.997C-5.732,6.804,0.327,-0.742,6.088,-4.913Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i65",
    transform: "matrix(1,0,0,1,521.677,471.015)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.04,-0.088C0.013,-0.074,-0.013,-0.059,-0.04,-0.045C-0.04,-0.045,-0.04,0.088,-0.04,0.088C-0.015,0.028,0.015,-0.028,0.04,-0.088Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i66",
    transform: "matrix(1,0,0,1,529.311,452.197)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-5.023,13.407C-4.899,13.178,-4.773,12.951,-4.646,12.724C-4.561,11.265,-4.415,9.861,-4.178,8.614C-2.555,0.089,3.071,-6.339,7.686,-13.168C7.686,-13.168,6.44,-13.407,6.44,-13.407C0.679,-9.236,-5.379,-1.69,-7.686,5.503C-7.686,5.503,-7.682,10.376,-7.682,10.376C-6.731,11.24,-5.841,12.257,-5.023,13.407Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i67",
    transform: "matrix(1,0,0,1,522.958,465.382)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M1.329,0.222C0.511,-0.928,-0.378,-1.945,-1.329,-2.809C-1.329,-2.809,-1.324,2.809,-1.324,2.809C-0.781,2.575,-0.232,2.371,0.318,2.183C0.645,1.524,0.979,0.869,1.329,0.222Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i68",
    transform: "matrix(1,0,0,1,556.071,413.014)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-1.493,0.113C1.198,-0.22,3.887,-0.069,6.535,0.423C6.535,0.423,4.83,-1.316,4.83,-1.316C1.282,-1.265,-2.261,-0.796,-5.682,0.09C-5.682,0.09,-6.535,1.316,-6.535,1.316C-4.915,0.753,-3.241,0.329,-1.493,0.113Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i69",
    transform: "matrix(1,0,0,1,555.425,406.962)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M1.423,0.601C1.423,0.601,-0.098,-0.952,-0.098,-0.952C-0.098,-0.952,-1.423,0.952,-1.423,0.952C-0.479,0.808,0.47,0.692,1.423,0.601Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i70",
    transform: "matrix(1,0,0,1,572.772,418.002)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M3.396,0.611C6.153,2.123,9.003,4.061,11.871,6.308C11.871,6.308,8.469,-1.371,8.469,-1.371C2.316,-4.813,-4.782,-6.405,-11.871,-6.304C-11.871,-6.304,-10.166,-4.564,-10.166,-4.564C-5.441,-3.687,-0.846,-1.716,3.396,0.611Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i71",
    transform: "matrix(1,0,0,1,569.086,407.023)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-13.76,-1.013C-13.76,-1.013,-12.238,0.54,-12.238,0.54C-7.366,0.076,-2.403,0.3,2.327,1.254C4.763,1.745,7.127,2.469,9.404,3.398C9.404,3.398,8.541,1.45,8.541,1.45C10.484,1.048,12.457,0.81,14.438,0.715C10.239,-1.245,5.719,-2.549,1.129,-3.087C-4.071,-3.697,-9.318,-3.39,-14.438,-2.348C-13.908,-2.345,-13.384,-2.349,-12.842,-2.331C-12.842,-2.331,-13.76,-1.013,-13.76,-1.013Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i72",
    transform: "matrix(1,0,0,1,566.897,431.634)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M14.851,15.968C14.796,15.552,14.759,15.135,14.754,14.714C15.116,15.208,15.499,15.684,15.878,16.165C15.878,16.165,29.029,18.685,29.029,18.685C28.762,17.911,28.501,17.146,28.254,16.398C28.254,16.398,27.134,13.87,27.134,13.87C27.134,13.87,-4.291,-18.197,-4.291,-18.197C-6.939,-18.689,-9.628,-18.84,-12.319,-18.507C-14.067,-18.291,-15.741,-17.867,-17.361,-17.304C-17.361,-17.304,-23.395,-8.631,-23.395,-8.631C-23.818,-3.046,-26.147,1.634,-29.029,6.081C-28.579,6.653,-28.134,7.233,-27.692,7.817C-27.692,7.817,14.851,15.968,14.851,15.968Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i73",
    transform: "matrix(1,0,0,1,578.319,429.471)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M6.324,-5.161C3.456,-7.408,0.606,-9.346,-2.151,-10.858C-6.393,-13.185,-10.988,-15.156,-15.713,-16.033C-15.713,-16.033,15.713,16.033,15.713,16.033C15.713,16.033,6.324,-5.161,6.324,-5.161Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i74",
    transform: "matrix(1,0,0,1,589.815,452.756)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.315,2.21C0.315,2.21,7.04,0.219,7.04,0.219C6.723,-0.677,6.413,-1.563,6.111,-2.437C6.111,-2.437,-7.04,-4.956,-7.04,-4.956C-4.106,-1.231,-0.686,2.099,3.099,4.956C1.5,3.041,0.315,2.21,0.315,2.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i75",
    transform: "matrix(1,0,0,1,567.084,453.503)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-11.721,4.424C-9.158,6.242,-6.767,7.745,-4.379,8.997C-0.542,7.705,3.599,6.886,7.603,6.895C9.513,6.899,11.615,7.109,13.434,7.714C15.308,8.337,16.743,9.557,17.967,11.079C18.963,12.317,17.211,14.089,16.206,12.84C15.096,11.459,13.905,10.386,12.16,9.937C10.499,9.51,8.721,9.35,7.01,9.394C4.329,9.463,1.614,9.895,-1.019,10.587C2.884,12.24,6.984,13.305,11.996,13.999C14.492,14.345,25.619,12.892,27.879,11.778C22.858,7.063,15.56,0.91,14.664,-5.9C14.664,-5.9,-27.879,-14.051,-27.879,-14.051C-22.908,-7.483,-18.356,-0.281,-11.721,4.424Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i76",
    transform: "matrix(1,0,0,1,539.016,415.571)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M9.487,-6.507C11.284,-6.993,13.124,-7.375,14.986,-7.658C14.986,-7.658,16.31,-9.562,16.31,-9.562C16.31,-9.562,15.106,-10.79,15.106,-10.79C7.877,-9.244,0.919,-6.219,-5.258,-2.135C-10.044,1.03,-14.629,5.12,-16.31,10.606C-16.31,10.606,-14.648,10.555,-14.648,10.555C-14.481,10.629,-14.321,10.712,-14.156,10.79C-8.535,2.483,-0.459,-3.818,9.487,-6.507Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i77",
    transform: "matrix(1,0,0,1,539.533,421.405)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M10.004,-7.075C10.004,-7.075,10.857,-8.301,10.857,-8.301C9.132,-7.854,7.436,-7.311,5.789,-6.658C-1.204,-3.885,-6.753,1.162,-10.857,7.173C-10.338,7.535,-9.826,7.907,-9.331,8.301C-3.937,1.768,2.344,-4.413,10.004,-7.075Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i78",
    transform: "matrix(1,0,0,1,555.183,405.342)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.143,0.667C0.143,0.667,1.061,-0.651,1.061,-0.651C0.519,-0.669,-0.005,-0.664,-0.535,-0.667C-0.71,-0.631,-0.886,-0.598,-1.061,-0.561C-1.061,-0.561,0.143,0.667,0.143,0.667Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i79",
    transform: "matrix(1,0,0,1,539.869,426.023)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M9.667,-11.693C2.007,-9.031,-4.273,-2.849,-9.667,3.684C-6.811,5.954,-4.338,8.727,-2.001,11.693C0.881,7.246,3.209,2.565,3.632,-3.02C3.632,-3.02,9.667,-11.693,9.667,-11.693Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i80",
    transform: "matrix(1,0,0,1,619.568,513.372)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M15.04,-26.463C15.04,-26.463,10.651,-30.941,10.651,-30.941C10.728,-30.017,10.771,-29.079,10.771,-28.128C10.771,-13.792,1.756,-2.171,-9.365,-2.171C-10.848,-2.171,-12.292,-2.384,-13.684,-2.776C-15.552,-0.412,-17.846,2.002,-20.755,4.899C-20.755,4.899,-19.9,4.656,-19.9,4.656C-23.509,12.267,-24.193,21.22,-21.784,29.291C-21.618,29.846,-21.435,30.396,-21.241,30.941C-20.793,30.915,-20.339,30.834,-19.907,30.744C-12.283,29.16,-4.64,27.199,2.216,23.507C9.072,19.815,16.79,13.933,19.75,6.731C21.666,2.069,22.858,-3.417,23.097,-8.451C23.279,-12.291,23.215,-16.121,22.974,-19.935C20.88,-22.646,18.199,-24.894,15.04,-26.463Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i81",
    transform: "matrix(1,0,0,1,596.66,531.174)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M3.008,-13.146C3.008,-13.146,2.153,-12.904,2.153,-12.904C1.935,-12.687,1.73,-12.479,1.505,-12.256C0.618,-9.672,-0.382,-7.531,-2.998,-4.44C-3.039,-3.001,-2.953,-1.566,-2.791,-0.087C-2.79,-0.074,-2.79,-0.063,-2.789,-0.05C-2.788,-0.039,-2.786,-0.033,-2.785,-0.022C-2.458,2.927,-1.848,6.057,-1.389,9.76C-1.252,10.867,-1.029,12.105,-0.111,12.738C0.407,13.095,1.029,13.175,1.667,13.138C1.473,12.593,1.29,12.044,1.124,11.489C-1.285,3.418,-0.601,-5.535,3.008,-13.146Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i82",
    transform: "matrix(1,0,0,1,595.913,522.827)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-1.695,-0.431C-2.041,1.05,-2.21,2.481,-2.251,3.908C0.365,0.817,1.364,-1.324,2.251,-3.908C2.251,-3.908,2.251,-3.908,2.251,-3.908C1.048,-2.716,-0.284,-1.557,-1.695,-0.431Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i83",
    transform: "matrix(1,0,0,1,613.033,450.565)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M4.76,-26.142C1.093,-30.95,-3.472,-35.113,-8.761,-38.043C-15.051,-41.528,-22.33,-43.171,-29.509,-42.827C-22.058,-39.35,-15.628,-33.784,-11.69,-26.593C-10.168,-23.814,-9.024,-20.847,-7.885,-17.89C-4.336,-8.679,-0.788,0.532,2.761,9.743C10.486,12.617,16.301,21.286,17.186,31.866C17.186,31.866,21.575,36.344,21.575,36.344C24.734,37.913,27.415,40.161,29.509,42.872C28.183,21.904,20.781,1.457,10.557,-17.04C8.815,-20.191,6.943,-23.279,4.76,-26.142Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i84",
    transform: "matrix(1,0,0,1,601.492,512.966)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-3.385,-4.207C-3.719,-3.101,-4.058,-2.037,-4.392,-1C-4.392,-1,-0.093,-3.083,-0.093,-3.083C-1.695,0.671,-2.424,3.238,-3.156,5.44C-3.156,5.44,-2.679,5.304,-2.679,5.304C0.23,2.407,2.524,-0.007,4.392,-2.371C2.24,-2.978,0.217,-4.024,-1.617,-5.44C-2.204,-5.026,-2.791,-4.612,-3.385,-4.207Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i85",
    transform: "matrix(1,0,0,1,598.489,518.595)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.324,0.324C-0.099,0.101,0.106,-0.107,0.324,-0.324C0.324,-0.324,-0.154,-0.188,-0.154,-0.188C-0.211,-0.017,-0.267,0.157,-0.324,0.324Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i86",
    transform: "matrix(1,0,0,1,598.129,514.639)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.206,3.768C0.938,1.566,1.667,-1.001,3.269,-4.755C3.269,-4.755,-1.03,-2.672,-1.03,-2.672C-1.86,-0.1,-2.658,2.304,-3.269,4.755C-3.269,4.755,0.206,3.768,0.206,3.768Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i87",
    transform: "matrix(1,0,0,1,596.277,520.401)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-1.417,-1.007C-1.655,-0.052,-1.866,0.91,-2.037,1.893C-2.045,1.927,-2.051,1.96,-2.059,1.994C-0.648,0.868,0.685,-0.291,1.888,-1.483C1.888,-1.483,1.888,-1.483,1.888,-1.483C1.945,-1.65,2.002,-1.823,2.059,-1.994C2.059,-1.994,-1.417,-1.007,-1.417,-1.007Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i88",
    transform: "matrix(1,0,0,1,596.683,461.44)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.758,3.727C1.694,2.737,2.702,1.856,3.768,1.094C1.133,-0.31,-1.385,-1.929,-3.768,-3.727C-2.403,-2.092,-0.738,0.336,0.758,3.727Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i89",
    transform: "matrix(1,0,0,1,591.462,428.826)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M10.22,12.195C6.263,3.426,0.329,-5.3,-7.851,-10.756C-8.622,-11.27,-9.415,-11.744,-10.22,-12.195C-10.22,-12.195,-6.819,-4.516,-6.819,-4.516C-1.007,0.037,4.877,5.886,10.22,12.195Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i90",
    transform: "matrix(1,0,0,1,596.711,434.023)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-18.221,-23.602C-14.449,-22.063,-10.916,-19.961,-7.7,-17.413C1.348,-10.244,7.308,0.217,11.295,10.888C12.242,13.422,13.117,16.022,13.866,18.66C13.982,18.83,14.098,18.999,14.213,19.169C14.213,19.169,16.252,19.56,16.252,19.56C16.588,20.957,16.892,22.364,17.172,23.777C17.645,24.552,18.106,25.324,18.547,26.089C18.727,26.149,18.906,26.219,19.084,26.285C15.535,17.074,11.987,7.863,8.438,-1.348C7.299,-4.305,6.155,-7.272,4.633,-10.051C0.695,-17.242,-5.735,-22.808,-13.186,-26.285C-15.167,-26.19,-17.141,-25.952,-19.084,-25.55C-19.084,-25.55,-18.221,-23.602,-18.221,-23.602Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i91",
    transform: "matrix(1,0,0,1,612.403,455.496)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.56,-1.913C0.56,-1.913,-1.479,-2.304,-1.479,-2.304C-0.437,-0.76,0.549,0.779,1.479,2.304C1.199,0.891,0.896,-0.516,0.56,-1.913Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i92",
    transform: "matrix(1,0,0,1,596.717,448.245)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.791,2.074C-0.791,2.074,2.685,2.74,2.685,2.74C2.685,2.74,-2.685,-2.74,-2.685,-2.74C-2.685,-2.74,-1.566,-0.213,-1.566,-0.213C-1.319,0.535,-1.058,1.3,-0.791,2.074Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i93",
    transform: "matrix(1,0,0,1,595.226,438.261)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-10.583,-13.951C-10.583,-13.951,-1.194,7.243,-1.194,7.243C-1.194,7.243,4.177,12.724,4.177,12.724C4.177,12.724,10.583,13.951,10.583,13.951C9.725,11.061,8.738,8.209,7.602,5.417C7.242,4.533,6.856,3.646,6.456,2.759C1.113,-3.55,-4.771,-9.398,-10.583,-13.951Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i94",
    transform: "matrix(1,0,0,1,614.57,458.956)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.688,1.156C0.247,0.391,-0.215,-0.381,-0.688,-1.156C-0.555,-0.486,-0.431,0.185,-0.312,0.857C0.024,0.946,0.358,1.046,0.688,1.156Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i95",
    transform: "matrix(1,0,0,1,610.75,452.938)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.173,0.255C0.058,0.085,-0.057,-0.085,-0.173,-0.255C-0.129,-0.098,-0.081,0.057,-0.037,0.214C-0.037,0.214,0.173,0.255,0.173,0.255Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i96",
    transform: "matrix(1,0,0,1,598.875,456.426)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-2.019,-3.451C-2.019,-3.451,-8.745,-1.46,-8.745,-1.46C-8.745,-1.46,-7.559,-0.629,-5.96,1.286C-3.577,3.084,-1.059,4.703,1.576,6.107C3.75,4.552,6.172,3.505,8.745,3.08C8.734,3.023,8.722,2.966,8.711,2.909C8.711,2.909,0.528,-5.441,0.528,-5.441C0.528,-5.441,-2.948,-6.107,-2.948,-6.107C-2.646,-5.233,-2.336,-4.347,-2.019,-3.451Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i97",
    transform: "matrix(1,0,0,1,603.494,455.16)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M4.092,4.175C3.867,3.041,3.635,1.907,3.35,0.782C3.033,-0.469,2.682,-1.711,2.315,-2.948C2.315,-2.948,-4.092,-4.175,-4.092,-4.175C-4.092,-4.175,4.092,4.175,4.092,4.175Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i98",
    transform: "matrix(1,0,0,1,612.486,456.483)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.327,2.928C0.384,3.016,1.086,3.15,1.773,3.331C1.654,2.659,1.53,1.987,1.397,1.317C0.467,-0.208,-0.52,-1.746,-1.562,-3.29C-1.562,-3.29,-1.773,-3.331,-1.773,-3.331C-1.199,-1.262,-0.707,0.829,-0.327,2.928Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i99",
    transform: "matrix(1,0,0,1,546.218,489.377)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9798",
    d: "M-4.38,6.456C-4.585,6.924,-4.512,7.529,-4.295,7.956C-4.103,8.333,-3.749,8.489,-3.418,8.611C-0.848,9.561,1.835,9.975,4.501,9.833C3.847,2.922,2.154,-3.813,-0.452,-9.86C-1.23,-4.249,-1.55,0,-4.38,6.456Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i100",
    transform: "matrix(1,0,0,1,532.524,467.561)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M6.128,0.987C7.723,1.137,7.713,-1.355,6.128,-1.504C1.735,-1.916,-3.008,-1.708,-7.321,-0.571C-6.885,0.145,-6.477,0.905,-6.094,1.699C-2.13,0.781,2.099,0.609,6.128,0.987Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i101",
    transform: "matrix(1,0,0,1,525.505,468.368)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.902,1.379C-0.526,1.26,-0.148,1.148,0.23,1.051C0.46,0.992,0.693,0.946,0.925,0.892C0.542,0.098,0.135,-0.663,-0.301,-1.379C-0.507,-1.325,-0.715,-1.273,-0.919,-1.214C-0.931,-0.35,-0.927,0.518,-0.902,1.379Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i102",
    transform: "matrix(1,0,0,1,520.636,470.161)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.178,1.253C0.444,1.094,0.724,0.952,1.001,0.808C1.001,0.808,0.999,-1.04,0.999,-1.04C0.919,-1.316,0.839,-1.592,0.767,-1.869C0.15,-1.593,-0.438,-1.275,-1.001,-0.931C-0.882,0,-0.767,0.934,-0.66,1.869C-0.401,1.647,-0.129,1.436,0.178,1.253Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i103",
    transform: "matrix(1,0,0,1,521.925,470.615)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.209,0.312C-0.07,0.241,0.068,0.169,0.209,0.102C0.163,-0.036,0.119,-0.174,0.074,-0.312C-0.018,-0.103,-0.12,0.102,-0.209,0.312Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i104",
    transform: "matrix(1,0,0,1,517.696,472.523)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-2.179,1.808C-2.8,3.283,-0.389,3.929,0.224,2.471C0.536,1.73,0.908,1.046,1.376,0.443C1.3,-0.443,1.222,-1.329,1.116,-2.212C1.116,-2.212,2.197,-0.432,2.197,-0.432C2.222,-0.454,2.254,-0.471,2.28,-0.493C2.173,-1.428,2.058,-2.361,1.939,-3.292C1.711,-3.153,1.474,-3.022,1.26,-2.871C-0.417,-1.685,-1.395,-0.055,-2.179,1.808Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i105",
    transform: "matrix(1,0,0,1,519.353,471.639)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.281,1.327C-0.036,1.012,0.238,0.721,0.54,0.453C0.54,0.453,-0.54,-1.327,-0.54,-1.327C-0.434,-0.444,-0.357,0.441,-0.281,1.327Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i106",
    transform: "matrix(1,0,0,1,521.519,468.656)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.115,-0.465C0.037,-0.432,-0.039,-0.398,-0.116,-0.364C-0.044,-0.087,0.036,0.189,0.116,0.465C0.116,0.465,0.115,-0.465,0.115,-0.465Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i107",
    transform: "matrix(1,0,0,1,523.301,468.935)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M1.285,-1.781C1.176,-1.75,1.063,-1.726,0.955,-1.693C0.632,-1.596,0.303,-1.482,-0.025,-1.37C-0.473,-0.468,-0.897,0.445,-1.302,1.367C-1.257,1.505,-1.213,1.643,-1.167,1.781C-0.369,1.401,0.461,1.077,1.302,0.811C1.277,-0.05,1.273,-0.917,1.285,-1.781Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i108",
    transform: "matrix(1,0,0,1,521.817,470.046)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.182,0.257C0.054,-0.136,-0.068,-0.529,-0.182,-0.924C-0.182,-0.924,-0.18,0.924,-0.18,0.924C-0.153,0.91,-0.127,0.895,-0.1,0.881C-0.011,0.671,0.09,0.466,0.182,0.257Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i109",
    transform: "matrix(1,0,0,1,522.455,468.934)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.821,-1.369C0.271,-1.181,-0.278,-0.977,-0.821,-0.743C-0.821,-0.743,-0.82,0.188,-0.82,0.188C-0.706,0.583,-0.584,0.976,-0.456,1.369C-0.051,0.447,0.373,-0.467,0.821,-1.369Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i110",
    transform: "matrix(1,0,0,1,533.924,480.458)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M0,-3.268C-1.417,-3.268,-2.566,-1.805,-2.566,0C-2.566,1.805,-1.417,3.268,0,3.268C1.417,3.268,2.566,1.805,2.566,0C2.566,-1.805,1.417,-3.268,0,-3.268Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i111",
    transform: "matrix(1,0,0,1,570.048,477.239)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M2.566,0C2.566,-1.805,1.417,-3.268,0,-3.268C-1.417,-3.268,-2.566,-1.805,-2.566,0C-2.566,1.805,-1.417,3.268,0,3.268C1.417,3.268,2.566,1.805,2.566,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i112",
    transform: "matrix(1,0,0,1,556.224,512.401)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M-1.628,6.785C6.821,5.612,14.089,-6.932,14.089,-6.932C14.089,-6.932,-14.089,-3.671,-14.089,-3.671C-14.089,-3.671,-8.14,6.128,-8.14,6.128C-6.334,6.826,-4.182,7.14,-1.628,6.785Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i113",
    transform: "matrix(1,0,0,1,543.909,513.63)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc7c9",
    d: "M-4.175,-4.622C-4.175,-4.622,-2.107,2.474,4.175,4.9C4.175,4.9,-1.774,-4.9,-1.774,-4.9C-1.774,-4.9,-4.175,-4.622,-4.175,-4.622Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i114",
    transform: "matrix(1,0,0,1,580.704,494.36)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9798",
    d: "M0,7.501C4.143,7.501,7.501,4.143,7.501,0C7.501,-4.143,4.143,-7.501,0,-7.501C-4.143,-7.501,-7.501,-4.143,-7.501,0C-7.501,4.143,-4.143,7.501,0,7.501Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i115",
    transform: "matrix(1,0,0,1,527.631,500.547)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9798",
    d: "M0.062,1.346C0.078,1.438,0.099,1.526,0.117,1.617C0.027,0.542,-0.038,-0.534,-0.082,-1.617C-0.155,-0.687,-0.114,0.315,0.062,1.346Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i116",
    transform: "matrix(1,0,0,1,534.822,496.683)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9798",
    d: "M-1.143,-1.883C-1.143,-1.883,1.143,1.883,1.143,1.883C0.613,0.289,-0.2,-1.026,-1.143,-1.883Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i117",
    transform: "matrix(1,0,0,1,532.078,501.156)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9798",
    d: "M1.242,7.388C3.654,6.977,5.046,3.333,4.35,-0.751C4.24,-1.396,4.08,-2.009,3.887,-2.59C3.887,-2.59,1.601,-6.355,1.601,-6.355C0.897,-6.995,0.123,-7.377,-0.658,-7.426C-0.64,-7.389,-0.621,-7.348,-0.603,-7.311C-0.764,-7.336,-0.931,-7.385,-1.094,-7.417C-1.155,-7.411,-1.216,-7.412,-1.277,-7.402C-2.219,-7.241,-3.003,-6.583,-3.57,-5.602C-3.836,-4.606,-4.139,-3.644,-4.476,-2.717C-4.496,-2.555,-4.516,-2.393,-4.529,-2.226C-4.485,-1.143,-4.42,-0.066,-4.33,1.009C-3.57,4.951,-1.115,7.79,1.242,7.388Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i118",
    transform: "matrix(1,0,0,1,528.055,496.996)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9798",
    d: "M0.453,-1.443C0,-0.66,-0.312,0.329,-0.453,1.443C-0.116,0.516,0.187,-0.447,0.453,-1.443Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i119",
    transform: "matrix(1,0,0,1,531.23,493.785)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ff9798",
    d: "M-0.246,-0.046C-0.083,-0.014,0.085,0.035,0.246,0.06C0.228,0.023,0.208,-0.018,0.19,-0.055C0.045,-0.064,-0.101,-0.06,-0.246,-0.046Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i120",
    transform: "matrix(1,0,0,1,561.338,464.716)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.053,0.898C0.511,0.719,0.976,0.55,1.444,0.385C0.531,-0.053,-0.365,-0.512,-1.241,-0.988C-1.799,-0.096,-1.15,1.367,0.053,0.898Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i121",
    transform: "matrix(1,0,0,1,563.081,463.8)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.376,-1.3C-1.044,-1.075,-1.705,-0.84,-2.352,-0.588C-2.642,-0.475,-2.848,-0.291,-2.984,-0.073C-2.108,0.403,-1.212,0.862,-0.299,1.3C0.775,0.922,1.872,0.582,2.984,0.29C1.854,-0.189,0.738,-0.716,-0.376,-1.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i122",
    transform: "matrix(1,0,0,1,574.026,463.584)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M5.218,-0.144C6.963,0.305,8.154,1.378,9.264,2.759C10.269,4.008,12.021,2.236,11.025,0.998C9.801,-0.524,8.366,-1.744,6.492,-2.367C4.673,-2.972,2.571,-3.182,0.661,-3.186C-3.343,-3.195,-7.484,-2.376,-11.321,-1.084C-10.207,-0.5,-9.091,0.028,-7.961,0.507C-5.328,-0.185,-2.613,-0.618,0.068,-0.687C1.779,-0.731,3.557,-0.571,5.218,-0.144Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i123",
    transform: "matrix(1,0,0,1,595.339,487.467)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-1.087,-18.057C-3.709,-13.675,-5.272,-8.186,-5.272,-2.224C-5.272,6.207,-2.152,13.695,2.679,18.437C3.045,18.184,3.416,17.939,3.779,17.682C4.356,15.438,4.875,12.996,5.272,10.269C2.644,6.575,1.028,1.666,1.028,-3.741C1.028,-8.4,2.233,-12.685,4.243,-16.149C4.031,-16.946,3.805,-17.706,3.568,-18.437C2.016,-18.324,0.464,-18.199,-1.087,-18.057Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i124",
    transform: "matrix(1,0,0,1,596.579,467.289)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M0.862,-2.122C-0.322,-0.869,-1.391,0.557,-2.327,2.122C-0.776,1.98,0.775,1.855,2.327,1.742C1.872,0.336,1.378,-0.952,0.862,-2.122Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i125",
    transform: "matrix(1,0,0,1,618.112,495.872)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M10.466,-12.145C10.466,-0.679,3.256,8.616,-5.639,8.616C-6.499,8.616,-7.338,8.505,-8.162,8.337C-9.282,10.637,-10.602,12.667,-12.228,14.724C-10.836,15.116,-9.392,15.329,-7.909,15.329C3.212,15.329,12.228,3.708,12.228,-10.628C12.228,-11.579,12.185,-12.517,12.108,-13.441C12.108,-13.441,10.257,-15.329,10.257,-15.329C10.382,-14.288,10.466,-13.231,10.466,-12.145Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i126",
    transform: "matrix(1,0,0,1,623.007,471.37)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-5.667,-7.434C0.086,-5.085,4.422,1.32,5.362,9.173C5.362,9.173,7.213,11.061,7.213,11.061C6.328,0.481,0.512,-8.187,-7.213,-11.061C-6.883,-10.205,-6.554,-9.35,-6.224,-8.494C-6.035,-8.139,-5.848,-7.785,-5.667,-7.434Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i127",
    transform: "matrix(1,0,0,1,604.912,506.712)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M1.246,-3.884C-0.802,-2.262,-2.897,-0.695,-5.037,0.814C-3.203,2.23,-1.18,3.277,0.972,3.884C2.598,1.827,3.917,-0.203,5.037,-2.503C3.715,-2.772,2.441,-3.227,1.246,-3.884Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i128",
    transform: "matrix(1,0,0,1,600.067,470.098)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-0.485,1.22C0.017,0.354,0.561,-0.466,1.16,-1.22C0.386,-1.172,-0.387,-1.124,-1.16,-1.068C-0.923,-0.337,-0.697,0.423,-0.485,1.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i129",
    transform: "matrix(1,0,0,1,601.592,501.443)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M2.474,-0.032C1.192,-1.047,0.031,-2.283,-0.981,-3.706C-1.378,-0.979,-1.897,1.462,-2.474,3.706C-0.782,2.509,0.863,1.255,2.474,-0.032Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i130",
    transform: "matrix(1,0,0,1,617.062,463.405)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M0.278,0.53C0.097,0.179,-0.089,-0.175,-0.278,-0.53C-0.151,-0.199,-0.023,0.13,0.104,0.461C0.162,0.484,0.22,0.506,0.278,0.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i131",
    transform: "matrix(1,0,0,1,601.529,465.782)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M4.088,-0.821C2.327,-1.543,0.602,-2.353,-1.078,-3.248C-2.144,-2.486,-3.152,-1.605,-4.088,-0.615C-3.572,0.555,-3.077,1.842,-2.622,3.248C-1.849,3.192,-1.076,3.145,-0.302,3.097C0.973,1.492,2.457,0.171,4.088,-0.821Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i132",
    transform: "matrix(1,0,0,1,616.021,461.494)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M0.763,1.382C0.433,0.526,0.104,-0.329,-0.226,-1.185C-0.404,-1.251,-0.583,-1.322,-0.763,-1.382C-0.227,-0.451,0.278,0.47,0.763,1.382Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i133",
    transform: "matrix(1,0,0,1,615.712,461.84)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-0.906,1.368C-0.1,1.519,0.692,1.728,1.454,2.027C1.327,1.696,1.199,1.366,1.072,1.035C0.587,0.123,0.082,-0.797,-0.454,-1.728C-0.784,-1.838,-1.118,-1.938,-1.454,-2.027C-1.254,-0.898,-1.067,0.233,-0.906,1.368Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i134",
    transform: "matrix(1,0,0,1,604.561,462.234)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M3.708,0.508C3.694,0.408,3.684,0.304,3.662,0.205C3.444,-0.77,3.253,-1.749,3.059,-2.727C0.486,-2.302,-1.936,-1.255,-4.11,0.3C-2.43,1.195,-0.705,2.005,1.056,2.727C2.025,2.137,3.046,1.67,4.11,1.338C3.903,1.105,3.754,0.828,3.708,0.508Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i135",
    transform: "matrix(1,0,0,1,613.483,461.309)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-1.098,1.662C-1.068,1.662,-1.04,1.656,-1.01,1.656C-0.215,1.656,0.56,1.756,1.324,1.899C1.163,0.764,0.976,-0.367,0.776,-1.496C0.089,-1.677,-0.613,-1.811,-1.324,-1.899C-1.194,-1.179,-1.075,-0.458,-0.973,0.263C-0.904,0.751,-0.945,1.234,-1.098,1.662Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i136",
    transform: "matrix(1,0,0,1,518.701,457.707)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M0.001,-0.001C0.031,-0.241,-0.034,0.242,0.001,-0.001C0.001,-0.001,0.001,-0.001,0.001,-0.001Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i137",
    transform: "matrix(1,0,0,1,521.392,443.356)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-2.782,15.078C-2.758,14.887,-2.732,14.696,-2.708,14.505C-2.699,14.433,-2.693,14.386,-2.689,14.35C-2.724,14.593,-2.659,14.11,-2.689,14.35C-2.684,14.313,-2.677,14.264,-2.666,14.188C-2.403,12.33,-2.109,10.477,-1.752,8.635C-1.168,5.617,-0.416,2.631,0.501,-0.304C0.61,-0.72,0.74,-1.133,0.884,-1.543C1.29,-2.766,1.724,-3.98,2.2,-5.178C3.526,-8.514,5.227,-11.764,7.284,-14.777C6.086,-15.612,4.818,-16.357,3.468,-16.994C2.132,-15.019,0.931,-12.933,-0.119,-10.752C-4.164,-2.355,-6.167,6.738,-7.284,15.941C-5.802,15.978,-4.37,16.343,-3.012,16.994C-2.977,16.692,-2.943,16.39,-2.907,16.088C-2.866,15.751,-2.825,15.415,-2.782,15.078Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i138",
    transform: "matrix(1,0,0,1,516.117,461.423)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-2.03,-1.978C-2.106,-1.343,-2.179,-0.708,-2.252,-0.073C-2.389,1.109,-1.143,2.126,-0.053,2.126C1.249,2.126,2.009,1.112,2.146,-0.073C2.185,-0.406,2.223,-0.739,2.262,-1.072C0.904,-1.723,-0.528,-2.089,-2.01,-2.126C-2.016,-2.077,-2.024,-2.027,-2.03,-1.978Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i139",
    transform: "matrix(1,0,0,1,522.084,442.432)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-0.191,0.619C-0.062,0.207,0.055,-0.209,0.191,-0.619C0.047,-0.209,-0.082,0.203,-0.191,0.619Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i140",
    transform: "matrix(1,0,0,1,555.646,410.333)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-5.256,2.771C-1.835,1.885,1.708,1.416,5.256,1.365C5.256,1.365,1.203,-2.771,1.203,-2.771C0.25,-2.68,-0.7,-2.564,-1.644,-2.42C-1.644,-2.42,-5.256,2.771,-5.256,2.771Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i141",
    transform: "matrix(1,0,0,1,569.045,411.98)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M12.197,4.651C12.197,4.651,9.445,-1.56,9.445,-1.56C7.168,-2.489,4.804,-3.213,2.368,-3.704C-2.362,-4.658,-7.325,-4.882,-12.197,-4.418C-12.197,-4.418,-8.143,-0.282,-8.143,-0.282C-1.054,-0.383,6.044,1.209,12.197,4.651Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i142",
    transform: "matrix(1,0,0,1,539.431,418.246)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M5.891,-3.499C7.538,-4.152,9.234,-4.695,10.959,-5.142C10.959,-5.142,14.571,-10.333,14.571,-10.333C12.709,-10.05,10.87,-9.668,9.073,-9.182C-0.873,-6.493,-8.95,-0.191,-14.571,8.116C-13.221,8.753,-11.953,9.498,-10.755,10.333C-6.651,4.322,-1.102,-0.726,5.891,-3.499Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i143",
    transform: "matrix(1,0,0,1,594.534,431.552)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-10.923,-13.482C-2.743,-8.026,3.191,0.7,7.148,9.469C10.354,13.254,13.363,17.2,16.043,21.131C15.294,18.493,14.419,15.893,13.472,13.359C9.485,2.688,3.525,-7.773,-5.523,-14.942C-8.739,-17.49,-12.271,-19.592,-16.043,-21.131C-16.043,-21.131,-13.292,-14.921,-13.292,-14.921C-12.487,-14.47,-11.694,-13.996,-10.923,-13.482Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i144",
    transform: "matrix(1,0,0,1,606.197,447.086)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-3.369,-3.408C-2.233,-0.616,-1.247,2.236,-0.389,5.126C-0.389,5.126,4.516,6.066,4.516,6.066C4.472,5.909,4.423,5.754,4.379,5.597C1.699,1.666,-1.31,-2.281,-4.516,-6.066C-4.116,-5.179,-3.729,-4.292,-3.369,-3.408Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i145",
    transform: "matrix(1,0,0,1,607.661,459.421)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M0.075,0.067C0.075,0.067,-0.075,-0.085,-0.075,-0.085C-0.064,-0.028,-0.052,0.028,-0.041,0.085C-0.003,0.079,0.037,0.073,0.075,0.067Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i146",
    transform: "matrix(1,0,0,1,608.984,455.85)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-1.398,3.485C-1.398,3.485,-1.249,3.638,-1.249,3.638C-0.44,3.51,0.383,3.436,1.219,3.436C1.879,3.436,2.531,3.48,3.175,3.56C2.795,1.461,2.303,-0.629,1.729,-2.698C1.729,-2.698,-3.175,-3.638,-3.175,-3.638C-2.808,-2.401,-2.457,-1.159,-2.14,0.092C-1.855,1.217,-1.623,2.351,-1.398,3.485Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i147",
    transform: "matrix(1,0,0,1,609.421,461.529)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-1.199,0.909C-1.177,1.008,-1.166,1.112,-1.152,1.212C-1.106,1.532,-0.958,1.809,-0.751,2.042C0.077,1.783,0.929,1.604,1.802,1.517C1.802,1.517,-1.686,-2.042,-1.686,-2.042C-1.724,-2.036,-1.764,-2.029,-1.802,-2.023C-1.608,-1.045,-1.417,-0.066,-1.199,0.909Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i148",
    transform: "matrix(1,0,0,1,610.138,461.167)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-2.403,-1.679C-2.403,-1.679,1.085,1.88,1.085,1.88C1.469,1.842,1.854,1.808,2.246,1.805C2.399,1.377,2.44,0.893,2.371,0.405C2.269,-0.316,2.151,-1.036,2.021,-1.756C1.377,-1.836,0.725,-1.88,0.065,-1.88C-0.771,-1.88,-1.594,-1.807,-2.403,-1.679Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i149",
    transform: "matrix(1,0,0,1,598.883,484.528)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#059e9e",
    d: "M1.729,13.209C2.212,9.892,2.516,6.156,2.516,1.824C2.516,-4.159,1.786,-9.124,0.699,-13.209C-1.311,-9.745,-2.516,-5.46,-2.516,-0.801C-2.516,4.606,-0.899,9.515,1.729,13.209Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i150",
    transform: "matrix(1,0,0,1,619.264,486.496)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#059e9e",
    d: "M-3.861,-17.992C-3.18,-9.874,-3.597,-1.691,-5.488,6.22C-6.638,11.032,-7.807,14.619,-9.314,17.713C-8.49,17.881,-7.651,17.992,-6.791,17.992C2.104,17.992,9.314,8.697,9.314,-2.769C9.314,-3.855,9.23,-4.912,9.105,-5.953C9.105,-5.953,-2.661,-17.96,-2.661,-17.96C-3.061,-17.969,-3.461,-17.986,-3.861,-17.992Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i151",
    transform: "matrix(1,0,0,1,622.486,472.239)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#059e9e",
    d: "M-5.883,-3.703C-5.883,-3.703,5.883,8.303,5.883,8.303C4.943,0.45,0.607,-5.954,-5.146,-8.303C-4.324,-6.703,-3.582,-5.136,-2.94,-3.623C-3.921,-3.663,-4.902,-3.682,-5.883,-3.703Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i152",
    transform: "matrix(1,0,0,1,607.645,486.348)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#059e9e",
    d: "M7.757,-17.844C3.027,-17.912,-1.699,-17.763,-6.418,-17.469C-7.017,-16.715,-7.562,-15.896,-8.064,-15.03C-6.977,-10.945,-6.247,-5.98,-6.247,0.003C-6.247,4.335,-6.551,8.072,-7.034,11.389C-6.022,12.812,-4.861,14.048,-3.579,15.063C-2.067,13.855,-0.582,12.621,0.84,11.33C2.025,10.254,3.791,12.011,2.602,13.091C1.779,13.838,0.919,14.546,0.058,15.248C-0.453,15.664,-0.97,16.071,-1.487,16.48C-0.292,17.137,0.982,17.592,2.304,17.861C3.811,14.767,4.981,11.18,6.131,6.368C8.022,-1.543,8.438,-9.726,7.757,-17.844Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i153",
    transform: "matrix(1,0,0,1,615.978,468.233)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#04adad",
    d: "M-0.575,0.271C-0.175,0.277,0.225,0.294,0.625,0.303C0.625,0.303,0.208,-0.122,0.208,-0.122C-0.071,-0.175,-0.347,-0.245,-0.625,-0.303C-0.608,-0.112,-0.591,0.08,-0.575,0.271Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i154",
    transform: "matrix(1,0,0,1,617.866,466.241)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#04adad",
    d: "M1.111,2.328C0.176,2.2,-0.754,2.046,-1.68,1.869C-1.68,1.869,-1.263,2.295,-1.263,2.295C-0.282,2.316,0.699,2.335,1.68,2.375C1.038,0.862,0.296,-0.706,-0.526,-2.306C-0.584,-2.33,-0.643,-2.352,-0.701,-2.375C-0.097,-0.808,0.507,0.761,1.111,2.328Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i155",
    transform: "matrix(1,0,0,1,608.315,466.92)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#059e9e",
    d: "M-2.697,-1.959C-4.328,-0.967,-5.813,0.354,-7.088,1.959C-2.369,1.665,2.358,1.516,7.088,1.584C7.072,1.393,7.055,1.201,7.038,1.01C3.711,0.32,0.448,-0.67,-2.697,-1.959Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i156",
    transform: "matrix(1,0,0,1,615.732,467.647)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#04adad",
    d: "M-0.379,0.283C-0.101,0.341,0.175,0.411,0.454,0.464C0.454,0.464,-0.454,-0.464,-0.454,-0.464C-0.43,-0.215,-0.401,0.034,-0.379,0.283Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i157",
    transform: "matrix(1,0,0,1,616.892,465.888)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#059e9e",
    d: "M-0.706,2.222C0.22,2.399,1.15,2.553,2.085,2.681C1.481,1.114,0.878,-0.455,0.274,-2.022C-0.488,-2.321,-1.279,-2.53,-2.085,-2.681C-1.898,-1.359,-1.745,-0.033,-1.614,1.295C-1.614,1.295,-0.706,2.222,-0.706,2.222Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i158",
    transform: "matrix(1,0,0,1,610.485,465.751)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#059e9e",
    d: "M0.489,-1.474C-0.268,-1.266,-1.262,-1.555,-1.814,-2.179C-2.878,-1.847,-3.899,-1.38,-4.868,-0.79C-1.723,0.499,1.541,1.489,4.868,2.179C4.846,1.93,4.816,1.682,4.792,1.433C4.792,1.433,1.417,-2.011,1.417,-2.011C1.178,-1.772,0.877,-1.581,0.489,-1.474Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i159",
    transform: "matrix(1,0,0,1,613.59,465.074)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#059e9e",
    d: "M-1.205,-2.103C-1.309,-1.813,-1.47,-1.553,-1.688,-1.335C-1.688,-1.335,1.688,2.109,1.688,2.109C1.557,0.781,1.403,-0.545,1.216,-1.867C0.452,-2.01,-0.322,-2.109,-1.117,-2.109C-1.147,-2.109,-1.175,-2.103,-1.205,-2.103Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i160",
    transform: "matrix(1,0,0,1,610.286,463.695)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#059e9e",
    d: "M0.687,0.582C1.075,0.475,1.377,0.284,1.616,0.045C1.616,0.045,0.937,-0.648,0.937,-0.648C0.064,-0.561,-0.788,-0.383,-1.616,-0.124C-1.064,0.5,-0.07,0.79,0.687,0.582Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i161",
    transform: "matrix(1,0,0,1,611.804,463.355)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#04adad",
    d: "M0.581,-0.384C0.189,-0.381,-0.197,-0.347,-0.581,-0.309C-0.581,-0.309,0.099,0.384,0.099,0.384C0.317,0.166,0.477,-0.094,0.581,-0.384Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i162",
    transform: "matrix(1,0,0,1,583.499,514.796)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M14.519,-8.891C9.239,-5.245,3.65,-2.002,-1.951,0.885C-6.268,3.11,-10.704,5.083,-15.24,6.812C-14.549,7.108,-14.032,7.563,-13.809,8.176C-13.725,8.406,-13.688,8.646,-13.689,8.891C-3.749,5.038,5.781,-0.009,14.607,-6.036C14.821,-6.745,15.033,-7.47,15.24,-8.217C14.996,-8.435,14.755,-8.659,14.519,-8.891Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i163",
    transform: "matrix(1,0,0,1,598.991,507.669)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.884,1.091C-0.29,0.686,0.297,0.271,0.884,-0.143C0.496,-0.442,0.118,-0.76,-0.252,-1.091C-0.459,-0.344,-0.67,0.382,-0.884,1.091Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i164",
    transform: "matrix(1,0,0,1,598.568,505.864)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.17,0.715C0.299,0.248,0.425,-0.231,0.55,-0.715C0.187,-0.458,-0.184,-0.212,-0.55,0.041C-0.314,0.273,-0.074,0.497,0.17,0.715Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i165",
    transform: "matrix(1,0,0,1,602.448,504.469)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-3.33,0.68C-3.455,1.164,-3.581,1.643,-3.71,2.11C-3.34,2.441,-2.962,2.759,-2.574,3.058C-0.434,1.549,1.662,-0.018,3.71,-1.64C2.98,-2.041,2.288,-2.528,1.618,-3.058C0.007,-1.771,-1.638,-0.517,-3.33,0.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i166",
    transform: "matrix(1,0,0,1,607.354,500.085)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M2.893,-0.646C4.082,-1.726,2.317,-3.483,1.132,-2.407C-0.29,-1.116,-1.776,0.118,-3.288,1.326C-2.618,1.856,-1.926,2.342,-1.196,2.743C-0.679,2.334,-0.161,1.927,0.35,1.511C1.211,0.809,2.07,0.101,2.893,-0.646Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i7",
    transform: "matrix(1,0,0,1,564.354,524.914)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-1.144,-3.143C-4.09,-2.069,-5.966,0.209,-5.333,1.945C-4.929,3.055,-3.594,3.668,-1.917,3.691C-1.917,3.691,-1.133,3.468,-1.133,3.468C-1.133,3.468,4.764,0.611,4.764,0.611C5.206,0.005,5.454,-0.627,5.456,-1.227C4.438,-0.832,3.416,-0.447,2.39,-0.078C0.876,0.467,0.231,-1.941,1.728,-2.48C2.459,-2.743,3.18,-3.03,3.906,-3.306C2.64,-3.849,0.763,-3.838,-1.144,-3.143Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,562.828,528.493)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.392,0.111C-0.277,0.113,-0.157,0.101,-0.039,0.097C-0.039,0.097,0.392,-0.111,0.392,-0.111C0.392,-0.111,-0.392,0.111,-0.392,0.111Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,566.169,526.953)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0.987,0.311C1.816,-0.194,2.488,-0.797,2.949,-1.429C2.949,-1.429,-2.949,1.429,-2.949,1.429C-2.949,1.429,0.987,0.311,0.987,0.311Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,564.973,527.927)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-2.183,0.663C-1.328,0.634,-0.407,0.473,0.528,0.132C1.13,-0.087,1.683,-0.358,2.183,-0.663C2.183,-0.663,-1.753,0.455,-1.753,0.455C-1.753,0.455,-2.183,0.663,-2.183,0.663Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,567.521,523.262)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M-0.777,1.574C0.249,1.205,1.271,0.82,2.289,0.425C2.29,0.18,2.253,-0.06,2.169,-0.29C1.946,-0.903,1.43,-1.358,0.739,-1.654C0.013,-1.378,-0.708,-1.091,-1.439,-0.828C-2.936,-0.289,-2.291,2.119,-0.777,1.574Z"
  }))))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,494.704,313.186)",
    id: "i167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc3c5",
    d: "M15.845,-9.273C14.927,-9.906,14.703,-11.145,14.566,-12.252C14.107,-15.955,13.498,-19.085,13.171,-22.034C13.17,-22.045,13.168,-22.051,13.167,-22.062C13.166,-22.075,13.166,-22.086,13.165,-22.099C13.003,-23.578,12.917,-25.012,12.958,-26.451C12.576,-25.999,12.168,-25.533,11.711,-25.036C10.326,-23.529,5.938,-18.236,3.894,-16.304C2.235,-14.736,-3.273,-11.553,-5.24,-10.64C-8.448,-9.15,-11.413,-7.673,-14.835,-7.283C-15.368,-7.222,-15.866,-7.166,-16.336,-7.118C-18.903,-6.021,-21.772,-5.96,-24.598,-6.196C-25.169,2.041,-28.574,10.11,-34.458,15.923C-29.677,21.946,-21.403,23.699,-13.801,24.86C-3.985,26.36,6.187,27.519,15.758,24.875C22.15,23.109,28.067,19.651,32.743,14.949C33.767,13.919,34.806,12.523,34.345,11.145C34.018,10.166,33.042,9.585,32.161,9.047C25.465,4.962,20.254,-1.488,17.623,-8.873C16.985,-8.836,16.363,-8.916,15.845,-9.273Z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-86,-240)",
    id: "i168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i169"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(531.951,564.705)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 0; 11; 0; 0; 11; 0; 0; 11; 0; 0",
    keyTimes: "0; 0.043794; 0.118246; 0.192691; 0.422834; 0.492149; 0.561461; 0.813804; 0.886967; 0.960133; 1",
    keySplines: "0 0 1 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.299 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.299 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-86,87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02aba1",
    d: "M97.009,-91.817C90.711,-91.817,84.779,-88.228,77.342,-85.625C69.33,-82.82,64.189,-77.602,58.382,-72.068C53.27,-67.197,41.636,-51.318,37.055,-45.944C24.022,-30.655,11.408,-12.941,-0.297,3.387C-9.308,15.957,-15.938,18.493,-28.115,28.029C-36.572,34.652,-46.473,39.111,-55.999,44.074C-69.334,51.022,-82.099,59.064,-94.123,68.092C-95.159,68.87,-96.236,69.716,-96.714,70.92C-97.169,72.068,-97.005,73.355,-96.834,74.578C-96.208,79.052,-95.582,83.525,-94.956,87.999C-94.845,88.791,-94.711,89.635,-94.172,90.226C-93.537,90.923,-92.517,91.081,-91.58,91.183C-83.175,92.101,-74.688,91.875,-66.245,91.424C-57.759,90.971,-49.246,90.285,-40.966,88.37C-32.724,86.464,-24.814,83.364,-16.938,80.275C-5.147,75.65,6.729,70.982,17.417,64.186C37.631,51.332,52.44,31.636,65.654,11.656C68.111,7.942,70.538,4.184,72.358,0.119C74.538,-4.75,75.805,-9.97,77.052,-15.157C79.473,-25.223,81.864,-35.295,84.225,-45.375"
  })))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-86,-240)",
    id: "i168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i8",
    transform: "matrix(1,0,0,1,579.896,651.832)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M22.719,-99.248C12.579,-90.905,2.598,-87.521,-11.719,-88.408C-18.083,-88.802,-21.892,-90.138,-26.272,-93.948C-31.821,-88.839,-36.472,-81.998,-37.756,-75.235C-41.843,-53.704,-42.081,-31.821,-42.31,-10.031C-42.675,24.693,-43.04,59.418,-43.405,94.142C-43.408,94.454,-43.403,94.79,-43.181,95.044C-42.922,95.341,-42.446,95.438,-42.011,95.513C-25.742,98.314,-9.001,99.261,7.582,98.321C15.053,97.897,22.808,97.123,29.835,99.248C28.824,89.909,31.725,80.623,34.298,71.488C39.945,51.438,44.128,30.941,43.301,10.373C43.025,3.495,42.189,-3.362,41.918,-10.24C41.462,-21.822,42.608,-33.41,42.451,-44.998C42.305,-55.828,41.018,-66.647,38.609,-77.296C36.664,-85.892,29.236,-92.333,22.719,-99.248"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,526.561,652.997)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M27.064,-95.113C26.568,-80.054,25.024,-66.525,24.875,-49.249C24.806,-41.288,24.405,-35.201,24.422,-27.245C24.434,-21.776,24.022,-16.313,23.611,-10.854C21.016,23.609,18.422,58.073,15.827,92.536C15.78,93.16,15.714,93.826,15.249,94.321C14.5,95.118,13.075,95.144,11.85,95.099C-1.121,94.623,-14.093,94.146,-27.064,93.67C-25.998,84.379,-24.931,75.088,-23.865,65.797C-22.782,56.36,-21.699,46.879,-22.377,37.417C-23.053,27.983,-25.475,18.657,-25.683,9.208C-25.821,2.954,-24.987,-3.284,-24.154,-9.501C-22.974,-18.308,-21.795,-27.115,-20.615,-35.922C-18.506,-51.666,-15.926,-68.37,-3.739,-80.651C-0.323,-84.093,3.74,-87.058,7.784,-90.007C13.041,-93.841,20.087,-94.393,27.064,-95.113"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,619.471,652.72)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#02b9b4",
    d: "M-16.856,-100.137C-16.255,-86.895,-16.502,-56.904,-18.073,-38.68C-22.559,13.357,-23.212,44.008,-33.491,95.217C-33.729,96.404,-33.901,97.797,-32.867,98.644C-32.049,99.314,-30.775,99.374,-29.624,99.393C-14.818,99.639,-0.011,99.886,14.795,100.132C15.692,100.147,16.651,100.148,17.404,99.744C18.259,99.285,18.634,98.424,18.941,97.62C24.876,82.066,25.821,65.546,26.339,49.241C27.026,27.622,27.043,5.989,26.389,-15.63C25.76,-36.446,24.569,-57.683,31.577,-77.683C32.606,-80.62,34.921,-83.377,32.817,-85.892C31.724,-87.198,28.76,-88.624,27.043,-89.336C15.179,-94.256,-4.066,-97.209,-16.856,-100.137"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,624.188,645.512)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#04adad",
    d: "M-31.114,55.753C-31.114,55.753,-17.553,50.494,-4.716,33.927C8.121,17.36,6.409,5.722,6.409,-3.494C6.409,-12.71,4.872,-63.618,22.427,-62.082C39.982,-60.546,25.5,24.813,25.5,24.813C25.5,24.813,2.678,51.145,2.678,51.145C2.678,51.145,-22.789,62.116,-22.789,62.116"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-86,-240)",
    id: "i168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i170"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(655.145,582.713)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0; 10; 0; 0; 10; 0; 0; 10; 0; 0",
    keyTimes: "0; 0.078827; 0.148897; 0.38206; 0.455455; 0.520688; 0.770764; 0.848233; 0.917093; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.299 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.299 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-655.145,-582.713)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,501.862,742.696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.699,-6.818C24.699,-6.818,4.105,-13.474,-4.453,-10.105C-13.011,-6.736,-24.943,-1.648,-24.696,10.968C-24.696,10.968,24.699,11.057,24.699,11.057",
    fill: "#ffc7c9"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "M24.699,-6.818C24.699,-6.818,4.105,-13.474,-4.453,-10.105C-13.011,-6.736,-24.943,-1.648,-24.696,10.968C-24.696,10.968,24.699,11.057,24.699,11.057; M26.853,0.822C26.853,0.822,5.826,-4.305,-2.462,-0.317C-10.75,3.671,-22.276,9.621,-21.104,22.185C-21.104,22.185,28.164,18.649,28.164,18.649; M24.699,-6.818C24.699,-6.818,4.105,-13.474,-4.453,-10.105C-13.011,-6.736,-24.943,-1.648,-24.696,10.968C-24.696,10.968,24.699,11.057,24.699,11.057; M24.699,-6.818C24.699,-6.818,4.105,-13.474,-4.453,-10.105C-13.011,-6.736,-24.943,-1.648,-24.696,10.968C-24.696,10.968,24.699,11.057,24.699,11.057; M26.853,0.822C26.853,0.822,5.826,-4.305,-2.462,-0.317C-10.75,3.671,-22.276,9.621,-21.104,22.185C-21.104,22.185,28.164,18.649,28.164,18.649; M24.699,-6.818C24.699,-6.818,4.105,-13.474,-4.453,-10.105C-13.011,-6.736,-24.943,-1.648,-24.696,10.968C-24.696,10.968,24.699,11.057,24.699,11.057; M24.699,-6.818C24.699,-6.818,4.105,-13.474,-4.453,-10.105C-13.011,-6.736,-24.943,-1.648,-24.696,10.968C-24.696,10.968,24.699,11.057,24.699,11.057; M26.853,0.822C26.853,0.822,5.826,-4.305,-2.462,-0.317C-10.75,3.671,-22.276,9.621,-21.104,22.185C-21.104,22.185,28.164,18.649,28.164,18.649; M24.699,-6.818C24.699,-6.818,4.105,-13.474,-4.453,-10.105C-13.011,-6.736,-24.943,-1.648,-24.696,10.968C-24.696,10.968,24.699,11.057,24.699,11.057; M24.699,-6.818C24.699,-6.818,4.105,-13.474,-4.453,-10.105C-13.011,-6.736,-24.943,-1.648,-24.696,10.968C-24.696,10.968,24.699,11.057,24.699,11.057",
    keyTimes: "0; 0.077684; 0.148897; 0.38206; 0.454386; 0.520688; 0.770764; 0.847107; 0.917093; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,599.011,660.713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.088,-94.633C46.586,-86.428,41.881,-75.371,39.266,-62.915C35.894,-46.852,37.218,-40.013,37.071,-21.524C36.988,-11.066,38.827,-0.389,35.316,12.821C32.596,23.054,24.463,27.911,14.903,32.402C5.343,36.893,-4.87,39.779,-14.807,43.351C-38.49,51.865,-60.987,58.058,-83.233,69.843C-90.09,73.476,-82.551,82.071,-82.639,83.437C-82.702,84.425,-82.188,85.347,-81.69,86.201C-77.549,93.307,-76.869,91.839,-72.974,94.391C-71.572,95.309,-67.201,93.254,-65.733,94.061C-64.329,94.833,-60.421,93.913,-58.821,93.841C-53.016,93.579,-46.332,93.742,-40.608,92.74C-11.071,87.568,14.428,96.142,42.06,84.462C49.605,81.273,57.202,77.751,63.157,72.113C71.593,64.126,75.874,52.73,78.996,41.521C90.766,-0.741,89.018,-48.514,65.614,-85.584C62.624,-90.32,56.983,-94.238,52.088,-94.633",
    fill: "#02b9b4"
  }, /*#__PURE__*/React.createElement("animate", {
    repeatCount: "indefinite",
    attributeName: "d",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "M52.088,-94.633C46.586,-86.428,41.881,-75.371,39.266,-62.915C35.894,-46.852,37.218,-40.013,37.071,-21.524C36.988,-11.066,38.827,-0.389,35.316,12.821C32.596,23.054,24.463,27.911,14.903,32.402C5.343,36.893,-4.87,39.779,-14.807,43.351C-38.49,51.865,-60.987,58.058,-83.233,69.843C-90.09,73.476,-82.551,82.071,-82.639,83.437C-82.702,84.425,-82.188,85.347,-81.69,86.201C-77.549,93.307,-76.869,91.839,-72.974,94.391C-71.572,95.309,-67.201,93.254,-65.733,94.061C-64.329,94.833,-60.421,93.913,-58.821,93.841C-53.016,93.579,-46.332,93.742,-40.608,92.74C-11.071,87.568,14.428,96.142,42.06,84.462C49.605,81.273,57.202,77.751,63.157,72.113C71.593,64.126,75.874,52.73,78.996,41.521C90.766,-0.741,89.018,-48.514,65.614,-85.584C62.624,-90.32,56.983,-94.238,52.088,-94.633; M52.088,-94.633C46.586,-86.428,41.881,-75.371,39.266,-62.915C35.894,-46.852,37.218,-40.013,37.071,-21.524C36.988,-11.066,35.136,-0.71,32.604,12.722C30.642,23.127,22.887,28.567,13.683,33.747C4.479,38.927,-5.495,42.555,-15.143,46.847C-38.137,57.076,-60.119,64.903,-81.441,78.289C-88.013,82.415,-79.864,90.435,-79.851,91.803C-79.842,92.793,-79.261,93.673,-78.702,94.489C-74.051,101.272,-73.481,99.759,-69.409,102.018C-67.944,102.831,-63.734,100.46,-62.211,101.157C-60.754,101.824,-56.924,100.619,-55.334,100.43C-49.564,99.743,-42.886,99.416,-37.251,97.996C-8.173,90.671,17.886,97.351,44.586,83.675C51.877,79.941,59.196,75.87,64.721,69.811C72.549,61.226,75.982,49.546,78.273,38.139C86.911,-4.873,89.018,-48.514,65.614,-85.584C62.624,-90.32,56.983,-94.238,52.088,-94.633; M52.088,-94.633C46.586,-86.428,41.881,-75.371,39.266,-62.915C35.894,-46.852,37.218,-40.013,37.071,-21.524C36.988,-11.066,38.827,-0.389,35.316,12.821C32.596,23.054,24.463,27.911,14.903,32.402C5.343,36.893,-4.87,39.779,-14.807,43.351C-38.49,51.865,-60.987,58.058,-83.233,69.843C-90.09,73.476,-82.551,82.071,-82.639,83.437C-82.702,84.425,-82.188,85.347,-81.69,86.201C-77.549,93.307,-76.869,91.839,-72.974,94.391C-71.572,95.309,-67.201,93.254,-65.733,94.061C-64.329,94.833,-60.421,93.913,-58.821,93.841C-53.016,93.579,-46.332,93.742,-40.608,92.74C-11.071,87.568,14.428,96.142,42.06,84.462C49.605,81.273,57.202,77.751,63.157,72.113C71.593,64.126,75.874,52.73,78.996,41.521C90.766,-0.741,89.018,-48.514,65.614,-85.584C62.624,-90.32,56.983,-94.238,52.088,-94.633; M52.088,-94.633C46.586,-86.428,41.881,-75.371,39.266,-62.915C35.894,-46.852,37.218,-40.013,37.071,-21.524C36.988,-11.066,38.827,-0.389,35.316,12.821C32.596,23.054,24.463,27.911,14.903,32.402C5.343,36.893,-4.87,39.779,-14.807,43.351C-38.49,51.865,-60.987,58.058,-83.233,69.843C-90.09,73.476,-82.551,82.071,-82.639,83.437C-82.702,84.425,-82.188,85.347,-81.69,86.201C-77.549,93.307,-76.869,91.839,-72.974,94.391C-71.572,95.309,-67.201,93.254,-65.733,94.061C-64.329,94.833,-60.421,93.913,-58.821,93.841C-53.016,93.579,-46.332,93.742,-40.608,92.74C-11.071,87.568,14.428,96.142,42.06,84.462C49.605,81.273,57.202,77.751,63.157,72.113C71.593,64.126,75.874,52.73,78.996,41.521C90.766,-0.741,89.018,-48.514,65.614,-85.584C62.624,-90.32,56.983,-94.238,52.088,-94.633; M52.088,-94.633C46.586,-86.428,41.881,-75.371,39.266,-62.915C35.894,-46.852,37.218,-40.013,37.071,-21.524C36.988,-11.066,35.136,-0.71,32.604,12.722C30.642,23.127,22.887,28.567,13.683,33.747C4.479,38.927,-5.495,42.555,-15.143,46.847C-38.137,57.076,-60.119,64.903,-81.441,78.289C-88.013,82.415,-79.864,90.435,-79.851,91.803C-79.842,92.793,-79.261,93.673,-78.702,94.489C-74.051,101.272,-73.481,99.759,-69.409,102.018C-67.944,102.831,-63.734,100.46,-62.211,101.157C-60.754,101.824,-56.924,100.619,-55.334,100.43C-49.564,99.743,-42.886,99.416,-37.251,97.996C-8.173,90.671,17.886,97.351,44.586,83.675C51.877,79.941,59.196,75.87,64.721,69.811C72.549,61.226,75.982,49.546,78.273,38.139C86.911,-4.873,89.018,-48.514,65.614,-85.584C62.624,-90.32,56.983,-94.238,52.088,-94.633; M52.088,-94.633C46.586,-86.428,41.881,-75.371,39.266,-62.915C35.894,-46.852,37.218,-40.013,37.071,-21.524C36.988,-11.066,38.827,-0.389,35.316,12.821C32.596,23.054,24.463,27.911,14.903,32.402C5.343,36.893,-4.87,39.779,-14.807,43.351C-38.49,51.865,-60.987,58.058,-83.233,69.843C-90.09,73.476,-82.551,82.071,-82.639,83.437C-82.702,84.425,-82.188,85.347,-81.69,86.201C-77.549,93.307,-76.869,91.839,-72.974,94.391C-71.572,95.309,-67.201,93.254,-65.733,94.061C-64.329,94.833,-60.421,93.913,-58.821,93.841C-53.016,93.579,-46.332,93.742,-40.608,92.74C-11.071,87.568,14.428,96.142,42.06,84.462C49.605,81.273,57.202,77.751,63.157,72.113C71.593,64.126,75.874,52.73,78.996,41.521C90.766,-0.741,89.018,-48.514,65.614,-85.584C62.624,-90.32,56.983,-94.238,52.088,-94.633; M52.088,-94.633C46.586,-86.428,41.881,-75.371,39.266,-62.915C35.894,-46.852,37.218,-40.013,37.071,-21.524C36.988,-11.066,38.827,-0.389,35.316,12.821C32.596,23.054,24.463,27.911,14.903,32.402C5.343,36.893,-4.87,39.779,-14.807,43.351C-38.49,51.865,-60.987,58.058,-83.233,69.843C-90.09,73.476,-82.551,82.071,-82.639,83.437C-82.702,84.425,-82.188,85.347,-81.69,86.201C-77.549,93.307,-76.869,91.839,-72.974,94.391C-71.572,95.309,-67.201,93.254,-65.733,94.061C-64.329,94.833,-60.421,93.913,-58.821,93.841C-53.016,93.579,-46.332,93.742,-40.608,92.74C-11.071,87.568,14.428,96.142,42.06,84.462C49.605,81.273,57.202,77.751,63.157,72.113C71.593,64.126,75.874,52.73,78.996,41.521C90.766,-0.741,89.018,-48.514,65.614,-85.584C62.624,-90.32,56.983,-94.238,52.088,-94.633; M52.088,-94.633C46.586,-86.428,41.881,-75.371,39.266,-62.915C35.894,-46.852,37.218,-40.013,37.071,-21.524C36.988,-11.066,35.136,-0.71,32.604,12.722C30.642,23.127,22.887,28.567,13.683,33.747C4.479,38.927,-5.495,42.555,-15.143,46.847C-38.137,57.076,-60.119,64.903,-81.441,78.289C-88.013,82.415,-79.864,90.435,-79.851,91.803C-79.842,92.793,-79.261,93.673,-78.702,94.489C-74.051,101.272,-73.481,99.759,-69.409,102.018C-67.944,102.831,-63.734,100.46,-62.211,101.157C-60.754,101.824,-56.924,100.619,-55.334,100.43C-49.564,99.743,-42.886,99.416,-37.251,97.996C-8.173,90.671,17.886,97.351,44.586,83.675C51.877,79.941,59.196,75.87,64.721,69.811C72.549,61.226,75.982,49.546,78.273,38.139C86.911,-4.873,89.018,-48.514,65.614,-85.584C62.624,-90.32,56.983,-94.238,52.088,-94.633; M52.088,-94.633C46.586,-86.428,41.881,-75.371,39.266,-62.915C35.894,-46.852,37.218,-40.013,37.071,-21.524C36.988,-11.066,38.827,-0.389,35.316,12.821C32.596,23.054,24.463,27.911,14.903,32.402C5.343,36.893,-4.87,39.779,-14.807,43.351C-38.49,51.865,-60.987,58.058,-83.233,69.843C-90.09,73.476,-82.551,82.071,-82.639,83.437C-82.702,84.425,-82.188,85.347,-81.69,86.201C-77.549,93.307,-76.869,91.839,-72.974,94.391C-71.572,95.309,-67.201,93.254,-65.733,94.061C-64.329,94.833,-60.421,93.913,-58.821,93.841C-53.016,93.579,-46.332,93.742,-40.608,92.74C-11.071,87.568,14.428,96.142,42.06,84.462C49.605,81.273,57.202,77.751,63.157,72.113C71.593,64.126,75.874,52.73,78.996,41.521C90.766,-0.741,89.018,-48.514,65.614,-85.584C62.624,-90.32,56.983,-94.238,52.088,-94.633; M52.088,-94.633C46.586,-86.428,41.881,-75.371,39.266,-62.915C35.894,-46.852,37.218,-40.013,37.071,-21.524C36.988,-11.066,38.827,-0.389,35.316,12.821C32.596,23.054,24.463,27.911,14.903,32.402C5.343,36.893,-4.87,39.779,-14.807,43.351C-38.49,51.865,-60.987,58.058,-83.233,69.843C-90.09,73.476,-82.551,82.071,-82.639,83.437C-82.702,84.425,-82.188,85.347,-81.69,86.201C-77.549,93.307,-76.869,91.839,-72.974,94.391C-71.572,95.309,-67.201,93.254,-65.733,94.061C-64.329,94.833,-60.421,93.913,-58.821,93.841C-53.016,93.579,-46.332,93.742,-40.608,92.74C-11.071,87.568,14.428,96.142,42.06,84.462C49.605,81.273,57.202,77.751,63.157,72.113C71.593,64.126,75.874,52.73,78.996,41.521C90.766,-0.741,89.018,-48.514,65.614,-85.584C62.624,-90.32,56.983,-94.238,52.088,-94.633",
    keyTimes: "0; 0.077684; 0.148897; 0.38206; 0.454386; 0.520688; 0.770764; 0.847107; 0.917093; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }))))))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-86,-240)",
    id: "i3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,494.821,755.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M365.356,-3.662C358.797,-3.662,352.237,-3.662,345.678,-3.662C327.988,-3.662,310.296,-3.662,292.606,-3.662C266.378,-3.662,240.151,-3.662,213.923,-3.662C181.924,-3.662,149.926,-3.662,117.927,-3.662C83.002,-3.662,48.075,-3.662,13.15,-3.662C-22.344,-3.662,-57.838,-3.662,-93.332,-3.662C-126.201,-3.662,-159.071,-3.662,-191.94,-3.662C-219.816,-3.662,-247.692,-3.662,-275.568,-3.662C-295.61,-3.662,-315.652,-3.662,-335.694,-3.662C-345.161,-3.662,-354.648,-3.843,-364.113,-3.662C-364.527,-3.654,-364.942,-3.662,-365.356,-3.662C-370.068,-3.662,-370.076,3.662,-365.356,3.662C-358.797,3.662,-352.237,3.662,-345.678,3.662C-327.988,3.662,-310.296,3.662,-292.606,3.662C-266.378,3.662,-240.151,3.662,-213.923,3.662C-181.924,3.662,-149.926,3.662,-117.927,3.662C-83.002,3.662,-48.075,3.662,-13.15,3.662C22.344,3.662,57.838,3.662,93.332,3.662C126.201,3.662,159.071,3.662,191.94,3.662C219.816,3.662,247.692,3.662,275.568,3.662C295.61,3.662,315.652,3.662,335.694,3.662C345.161,3.662,354.648,3.843,364.113,3.662C364.527,3.654,364.942,3.662,365.356,3.662C370.068,3.662,370.076,-3.662,365.356,-3.662C365.356,-3.662,365.356,-3.662,365.356,-3.662Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,399.369,748.189)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#80b8bc",
    d: "M176.937,4.715C176.937,4.715,-176.937,4.715,-176.937,4.715C-178.92,4.715,-180.527,3.107,-180.527,1.124C-180.527,1.124,-180.527,-1.124,-180.527,-1.124C-180.527,-3.107,-178.92,-4.715,-176.937,-4.715C-176.937,-4.715,176.937,-4.715,176.937,-4.715C178.92,-4.715,180.527,-3.107,180.527,-1.124C180.527,-1.124,180.527,1.124,180.527,1.124C180.527,3.107,178.92,4.715,176.937,4.715Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i9",
    transform: "matrix(1,0,0,1,324.766,675.775)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#80b8bc",
    d: "M115.285,77.129C115.285,77.129,-100.248,77.129,-100.248,77.129C-103.169,77.129,-105.618,74.924,-105.924,72.019C-105.924,72.019,-120.961,-70.824,-120.961,-70.824C-121.316,-74.194,-118.673,-77.129,-115.285,-77.129C-115.285,-77.129,102.253,-77.129,102.253,-77.129C105.204,-77.129,107.669,-74.879,107.937,-71.94C107.937,-71.94,120.969,70.903,120.969,70.903C121.274,74.246,118.642,77.129,115.285,77.129Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,317.744,675.775)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#94d5db",
    d: "M115.285,77.129C115.285,77.129,-100.248,77.129,-100.248,77.129C-103.169,77.129,-105.618,74.924,-105.924,72.019C-105.924,72.019,-120.961,-70.824,-120.961,-70.824C-121.316,-74.194,-118.673,-77.129,-115.285,-77.129C-115.285,-77.129,102.253,-77.129,102.253,-77.129C105.204,-77.129,107.669,-74.879,107.937,-71.94C107.937,-71.94,120.969,70.903,120.969,70.903C121.274,74.246,118.642,77.129,115.285,77.129Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,309.295,677.666)",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M11.942,0C11.942,6.595,6.595,11.942,0,11.942C-6.595,11.942,-11.942,6.595,-11.942,0C-11.942,-6.595,-6.595,-11.942,0,-11.942C6.595,-11.942,11.942,-6.595,11.942,0Z"
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(507.814,280.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -12; -12; 0; 0; -12; 0; 0",
    keyTimes: "0; 0.109635; 0.395349; 0.504984; 0.740863; 0.850498; 0.996678; 1",
    keySplines: "0.333 0 0.667 1; 0.298 0 0.667 1; 0.333 0 0.667 1; 0.298 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-593.814,-520.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i171"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(552.047,478.599)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 0 0; 1 1; 1 1",
    keyTimes: "0; 0.036545; 0.079734; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-550.047,-478.849)"
  }))))))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(507.814,280.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -12; -12; 0; 0; -12; 0; 0",
    keyTimes: "0; 0.109635; 0.395349; 0.504984; 0.740863; 0.850498; 0.996678; 1",
    keySplines: "0.333 0 0.667 1; 0.298 0 0.667 1; 0.333 0 0.667 1; 0.298 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-593.814,-520.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(535.924,480.208)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 0 0; 1 1; 1 1; 0 0; 1 1; 1 1; 0 0; 1 1; 1 1",
    keyTimes: "0; 0.036545; 0.079735; 0.408638; 0.445183; 0.488372; 0.760797; 0.797343; 0.840532; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.304 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.302 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-533.924,-480.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i4",
    transform: "matrix(1,0,0,1,533.924,480.458)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0,-3.268C-1.417,-3.268,-2.566,-1.805,-2.566,0C-2.566,1.805,-1.417,3.268,0,3.268C1.417,3.268,2.566,1.805,2.566,0C2.566,-1.805,1.417,-3.268,0,-3.268Z"
  }))))))))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(507.814,280.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -12; -12; 0; 0; -12; 0; 0",
    keyTimes: "0; 0.109635; 0.395349; 0.504984; 0.740863; 0.850498; 0.996678; 1",
    keySplines: "0.333 0 0.667 1; 0.298 0 0.667 1; 0.333 0 0.667 1; 0.298 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-593.814,-520.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(568.169,476.989)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "scale",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "1 1; 0 0; 1 1; 1 1; 0 0; 1 1; 1 1; 0 0; 1 1; 1 1",
    keyTimes: "0; 0.036545; 0.079735; 0.408638; 0.445183; 0.488372; 0.760797; 0.797343; 0.840532; 1",
    keySplines: "0.333 0 0.667 1; 0.333 0 0.667 1; 0.304 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0.302 0 0.667 1; 0.333 0 0.667 1; 0.333 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-566.169,-477.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5",
    transform: "matrix(1,0,0,1,566.169,477.239)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0b0042",
    d: "M0,-3.268C-1.417,-3.268,-2.566,-1.805,-2.566,0C-2.566,1.805,-1.417,3.268,0,3.268C1.417,3.268,2.566,1.805,2.566,0C2.566,-1.805,1.417,-3.268,0,-3.268Z"
  }))))))))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "i11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(507.814,280.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    repeatCount: "indefinite",
    type: "rotate",
    attributeName: "transform",
    dur: "5.017s",
    begin: "0s",
    calcMode: "spline",
    values: "0; -12; -12; 0; 0; -12; 0; 0",
    keyTimes: "0; 0.109635; 0.395349; 0.504984; 0.740863; 0.850498; 0.996678; 1",
    keySplines: "0.333 0 0.667 1; 0.298 0 0.667 1; 0.333 0 0.667 1; 0.298 0 0.667 1; 0.333 0 0.667 1; 0.167 0 0.667 1; 0 0 1 1",
    fill: "freeze"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1,1) translate(-593.814,-520.47)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,555.024,512.401)",
    id: "i172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-12.889,-3.671C-12.889,-3.671,-15.29,-3.394,-15.29,-3.394C-15.29,-3.394,-13.222,3.702,-6.94,6.128C-5.134,6.826,-2.981,7.14,-0.427,6.785C8.022,5.612,15.29,-6.932,15.29,-6.932C15.29,-6.932,-12.889,-3.671,-12.889,-3.671Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.99d7fc401356b6e4d1b0c08590168ac2.svg";
export { ForwardRef as ReactComponent };